window.__pt = window.__pt || {};
window.__pt.ln = window.__pt.ln || {};
window.__pt.settings = window.__pt.settings || {};

/** Dates */
window.__pt.settings.formatBoxDate = "MMM D, YYYY";
window.__pt.settings.formatBoxDateMobile = "MMM D";
window.__pt.settings.formatDate = "yyyy-MM-dd";
window.__pt.settings.formatMomentDate = "YYYY-MM-DD";
window.__pt.settings.formatDateSlash = "MMM dd, yyyy";

window.__pt.ln = {
    yourSelectionIncludes: "Your selection includes {0}<br> {1} of the {2} <br>requested in your search.<br>We suggest reviewing your selection.",
    uriHotels: "/hotels",
    and: "and",
    continue: 'Continue',
    total: "Total",
    dateFrom: "From",
    dateTo: "to",
    nights: "nights",
    night: "night",
    nightm: "night",
    nighstm: "nights",
    person: "person",
    persons: "people",
    pay: 'Book now',
    adult: 'adult',
    adults: 'adults',
    persons: 'people',
    person: 'person',
    child: 'child',
    children: 'children',
    the: 'from',
    years: 'years',
    year: 'year',
    minore: 'child',
    minores: 'children',
    room: 'room',
    rooms: 'rooms',
    selecteds: "selected",
    selected: "selected",
    for: "for",
    fora: "by",
    free: 'Free',
    locale_lang: "es",
    locale: 'es-es',
    loading: 'loading..',
    ok: 'Accept',
    cancel: 'Cancel',
    capacity: 'Sleeps {0}',
    kidsFreeTo: 'from 0 to {0} years',
    errorLogin: "An unexpected error occurred.",
    errorVerification:"An unexpected error occurred during email verification.",
    errorConfigSesion: "An unexpected error occurred during session setup.",
    errorDeletingAccount: "Error deleting account: ",
    noUserLoggedIn: "No user is currently logged in.",
    errorSendingPasswordResetEmail: "Error sending password reset email.",
    errorSigningOut: "Error signing out:",
    errorResendingVerificationEmail: "Error resending verification email:",
    uniqueRoom: "Unique room",
    recommendedRoom: "Recommended room",
    guests: "guests",
    roomTypes: "Room types",
    remainings:"Remaining",
    remaining:"Remaining",
    rating: {
        "10": "Excellent",
        "9": "Outstanding",
        "8": "Very good",
        "7": "Good",
        "default": "Convenient",
    },
    rating_reviews_range: [
        {
            "display": "Exceptional",
            "range": [10, 10]
        },
        {
            "display": "Excellent",
            "range": [9, 9.9]
        },
        {
            "display": "Very Good",
            "range": [8, 8.9]
        },
        {
            "display": "Good",
            "range": [7, 7.9]
        },
        {
            "display": "Acceptable",
            "range": [6, 6.9]
        },
        {
            "display": "Regular",
            "range": [5, 5.9]
        },
        {
            "display": "Poor",
            "range": [4, 4.9]
        },
        {
            "display": "Bad",
            "range": [3, 3.9]
        },
        {
            "display": "Very Bad",
            "range": [2, 2.9]
        },
        {
            "display": "Terrible",
            "range": [0, 1.9]
        }
    ],
    rating_reviews: {
        "1": "Terrible",
        "2": "Poor",
        "3": "Okay",
        "4": "Good",
        "5": "Excellent",
    },
    promotions_keys: {
        "106": "Midweek offer",
        "96": "Hot Sale",
        "115": "Oferta Buen Fin"
    },
    hotel_lang: "Hotel",
    flight_round_pricetravel: "Flight Round",
    flight_round_tiquetesbaratos: "Round-trip flight",
    flight_one_way_pricetravel: "Flight One Way",
    flight_one_way_tiquetesbaratos: "One-way flight",
    package_lang: "Hotel + Flight",
    new_room: "Rm.",
    new_pers: "pers.",
    price_calendar_footer: "Approximate prices in {currency} for a 1-night stay to 2 adults",
    day: "day",
    days: "days",
    low_prices: "Low prices",
    lower_prices: "Even lower prices",
    "to": "to",
    goToImage: "Go to image {0}",
    nearby: "Near",
    price_asc: 'Price (lowest to highest)',
    price_desc: 'Price (highest to lowest)',
    stars_desc: 'Stars (highest to lowest)',
    savings: 'Highest savings',
    add_more_rooms: 'add more rooms'
};

window.__pt.ln.availabilityMessages = {
    "minimumstay": {
        "title1": "Rooms with minimum stay",
        "title2": "Try booking a minimum of {{days}} nights"
    },
    "maximumstay": {
        "title1": "Rooms with maximum stay",
        "title2": "Try booking a maximum of {{days}} nights"
    },
    "none": {
        "title1": "Not available for the selected dates",
        "title2": "Try changing the dates or call toll free"
    },
    "peoplemax": {
        "title1": "Maximum guest capacity",
        "title2": "Try changing the number of people or rooms"
    },
    "adultsmax": {
        "title1": "You exceed the limit of adults per room",
        "title2": "Try changing the number of rooms"
    },
    "kidsmax": {
        "title1": "You exceed the limit of children per room",
        "title2": "Try changing the number of people or rooms"
    },
    "kidszero": {
        "title1": "You exceed the limit of children per room",
        "title2": "Try selecting adults only"
    },
    "defaults": { "minimumstay": 5, "maximumstay": 30 },
     "needhelp": "Need help? Contact our advisors at "
};

window.__pt.ln.mealplans = {
    "A": "American breakfast",
    "AA": "Imperial Christmas and New Years Eve",
    "AB": "Romantic Getaway",
    "AC": "Romantic Getaway and Spa",
    "AD": "Lunch and dinner with drinks",
    "AE": "Breakfast (adults only)",
    "AF": "Gourmet American Breakfast",
    "AG": "Breakfast for 2",
    "AH": "Continental Breakfast for 2",
    "AI": "Breakfast & lunch",
    "AJ": "Breakfast, lunch, dinner with liquids",
    "AK": "Semi All Inclusive",
    "KA": "Semi All Inclusive",
    "AL": "3 meals + 2 snacks",
    "AM": "Dining Plan",
    "AN": "Quick Service",
    "AO": "Breakfast, lunch or dinner included, beverages not included",
    "AP": "Breakfast, snack & dinner included",
    "AQ": "Breakfast, lunch or dinner included",
    "AS": "Drinks Included",
    "AT": "Breakfast, lunch, and dinner available only for adults",
    "AU": "Continental breakfast adults only",
    "AV": "Breakfast",
    "AW": "Food, Beverages and Tours included",
    "AX": "Breakfas for 1 adult",
    "AY": "Dinner",
    "AZ": "All Inclusive",
    "B": "Buffet breakfast",
    "BA": "Premium",
    "C": "Lunch",
    "E": "Room Only",
    "F": "Breakfast & dinner included",
    "G": "Breakfast, lunch & dinner included",
    "H": "Breakfast, lunch or dinner included",
    "I": "All Inclusive",
    "J": "Continental breakfast buffet",
    "K": "Food and drinks included",
    "L": "Breakfast",
    "M": "Breakfast & dinner with beberages",
    "N": "Breakfast without beverages",
    "O": "Open Bar",
    "P": "Breakfast & dinner, no drinks",
    "Q": "Breakfast, lunch & dinner, no drinks",
    "R": "Buffet breakfast, no beverages",
    "S": "Breakfast and lunch or dinner, beverages not included",
    "T": "Lunch without beverages",
    "U": "2 quick service meals + 1 snack",
    "V": "2 meals + 1 snack",
    "W": "3 meals, no beverages",
    "X": "Dinner without beverages",
    "Y": "Continental breakfast without beverages",
    "Z": "Continental breakfast",
    "AR": "Room Only",
    "BA": "All Inclusive Premium",
    "BB": "Resort credit included",
    "BZ": "Buffet breakfast",
    "EL": "Room Only with promo",
    "GR": "Breakfast, lunch & dinner included",
    "HR": "Breakfast, lunch or dinner included",
    "KR": "Food and drinks included",
    "MR": "Breakfast & dinner with beberages",
    "PR": "Breakfast and Dinner",
    "XB": "Golf AM - Buffet breakfast",
    "XE": "Golf AM - Room Only",
    "ZA": "American breakfast",
    "ZR": "Continental breakfast",
    "KITCHEN": "With kitchen"
};

window.__pt.ln.freecancellation = {
    "notallowed": "No refund",
    "allowed": "Free cancellation",
};

window.__pt.ln.promotion = {
    "40%dedescuento+2niñosgratis": "40% of discount + 2 children free",
    "ventaespecial": "Special Sale",
    "60%dedescuento": "Promotion 60% discount",
    "30%dedescuento": "Promotion 30% discount",
    "ofertadeverano": "Summer Sale",
    "20-30": "20% discount",
    "30-40": "30% discount",
    "40-50": "40% discount",
    "50-100": "Up to 50% discount",
    "hotsale": "Hot Sale",
    "festivaldeviajes": "Travel sale",
    "travelsale": "Travel Sale",
    "megaofertas": "Mega Deals"
};
window.__pt.ln.campaigns = {
    "hotsale": "Hot Sale",
    "ofertahot": "Hot Offer",
    "buenfin": "Buen Fin",
    "blackdays": "Black Days",
    "blackfriday": "Black Friday",
    "ofertaimperdible": "Unmissable Offer",
    "outlet": "Outlet",
    "megaoferta": "Mega Offer"
};
window.__pt.ln.paymentmethods = {
    "2": "Pay at property"
}
window.__pt.ln.stars = {
    "5": "5 stars",
    "4": "4 stars",
    "3": "3 stars",
    "2": "2 stars",
    "1": "1 star"
};

window.__pt.ln.reviews = {
    "dwonderful": "Excellent 9.0+",
    "bverygood": "Very Good 8.0+",
    "agood": "Good 7.0+"
};
window.__pt.ln.filterslang = {
    "zones": "zonas",
    "amenities": "amenidades",
    "room-view": "vista-de-la-habitacion",
    "interest": "interes"
};
window.angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "a.m.",
                "p.m."
            ],
            "DAY": [
                "domingo",
                "lunes",
                "martes",
                "mi\u00e9rcoles",
                "jueves",
                "viernes",
                "s\u00e1bado"
            ],
            "ERANAMES": [
                "antes de Cristo",
                "despu\u00e9s de Cristo"
            ],
            "ERAS": [
                "a. C.",
                "d. C."
            ],
            "FIRSTDAYOFWEEK": 0,
            "MONTH": [
                "january",
                "february",
                "march",
                "april",
                "may",
                "june",
                "july",
                "august",
                "september",
                "october",
                "november",
                "december"
            ],
            "SHORTDAY": [
                "Sun.",
                "Mon.",
                "Tues.",
                "Wed.",
                "Thurs.",
                "Fri.",
                "sat."
            ],
            "SHORTMONTH": [
                "Jan.",
                "Feb.",
                "Mar.",
                "Apr.",
                "May.",
                "Jun.",
                "Jul.",
                "Aug.",
                "Sept.",
                "Oct.",
                "Nov.",
                "Dec."
            ],
            "STANDALONEMONTH": [
                "january",
                "february",
                "march",
                "april",
                "may",
                "june",
                "july",
                "august",
                "september",
                "october",
                "november",
                "december"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "EEEE, y 'de' MMMM 'de' d",
            "longDate": "y 'de' MMMM 'de' d",
            "medium": "y MMM d HH:mm:ss",
            "mediumDate": "y MMM d",
            "mediumTime": "HH:mm:ss",
            "short": "yy/M/d HH:mm",
            "shortDate": "yy/M/d",
            "shortTime": "HH:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "-\u00a4",
                    "negSuf": "",
                    "posPre": "\u00a4",
                    "posSuf": ""
                }
            ]
        },
        "id": "en",
        "localeID": "en",
        "pluralCat": function (n, opt_precision) { if (n == 1) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
    });
}]);


window.__pt.settings.loginErrors = {
  "auth/account-exists-with-different-credential": "Email already in use with different credentials",
  "auth/email-already-in-use": "Email address is already in use by another account",
  "auth/invalid-email": "Email address is badly formatted",
  "auth/operation-not-allowed": "Operation not allowed",
  "auth/weak-password": "Password is too weak",
  "auth/auth-domain-config-required": "Unauthorized provider",
  "auth/cancelled-popup-request": "Login cancelled",
  "auth/operation-not-supported-in-this-environment": "Password login is disabled for this project",
  "auth/user-disabled": "User account has been disabled by an administrator",
  "auth/user-not-found": "No user found with this email address",
  "auth/wrong-password": "Incorrect password or user has no password",
  "auth/too-many-requests": "Access blocked due to unusual activity. Try again later",
  "auth/invalid-verification-code": "Invalid verification code",
  "auth/invalid-verification-id": "Invalid verification ID",
  "auth/missing-verification-code": "Missing verification code",
  "auth/missing-verification-id": "Missing verification ID",
  "auth/credential-already-in-use": "Credential is already in use",
  "auth/expired-action-code": "Password reset link has expired",
  "auth/invalid-action-code": "Password reset link is invalid",
  "auth/invalid-credential": "Invalid credential",
  "auth/invalid-phone-number": "Invalid phone number format",
  "auth/missing-phone-number": "Missing phone number",
  "auth/quota-exceeded": "Quota exceeded",
  "auth/timeout": "Operation timed out",
  "auth/provider-already-linked": "Provider is already linked",
  "auth/requires-recent-login": "Requires recent authentication",
  "auth/unauthorized-domain": "Unauthorized domain",
  "auth/invalid-api-key": "Invalid API key",
  "auth/network-request-failed": "Network error occurred"
}

window.__pt.ln.overriteTitles = {
    "Amenidades": "Instalaciones y servicios"
}

window.__pt.ln.paths = {
    "listPath": "hotels-in-",
};


window.__pt.ln.numberWords = {
    units: [
        'zero','one','two','three','four','five','six','seven','eight','nine','ten',
        'eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen'
    ],
    tens: {
        20: 'twenty', 30: 'thirty', 40: 'forty',
        50: 'fifty', 60: 'sixty', 70: 'seventy', 80: 'eighty', 90: 'ninety'
    },
    magnitude: {
        thousand: 'thousand',
        millionSingular: 'million',
        millionPlural: 'million'
    },
    joiner: '-'
};

window.__pt.ln.currencyWords = {
    MXN: 'Mexican pesos',
    USD: 'US dollars',
    COP: 'Colombian pesos',
    CAD: 'Canadian dollars',
    EUR: 'Euros',
    ARS: 'Argentine pesos',
    BRL: 'Brazilian reais',
    CLP: 'Chilean pesos',
    CNY: 'Chinese yuan',
    GBP: 'Pound sterling',
    JPY: 'Japanese yen',
    PEN: 'Peruvian soles',
    UYU: 'Uruguayan pesos'
};

window.__pt.ln.bedspreference = {
    "2": "Cookware & Kitchen Utensils",
    "3": "Crockery & Cutlery",
    "4": "Iron & Ironing Board",
    "5": "Drying Rack",
    "6": "Hair Dryer",
    "7": "Bed Linen & Towels",
    "8": "Toiletries",
    "9": "Central Heating",
    "11": "Washing Machine",
    "13": "Dishwasher",
    "17": "Kettle",
    "19": "Cable TV",
    "21": "Alarm Clock",
    "22": "Stereo",
    "23": "DVD",
    "24": "CD player",
    "25": "Video (VHS) Player",
    "27": "There is also a second separate toilet",
    "29": "Bidet",
    "32": "Cupboard",
    "33": "Vanity cupboard",
    "35": "Jacuzzi bath with shower",
    "36": "Washbasin with mirror",
    "37": "Toilet",
    "46": "Shower unit",
    "50": "Shower room",
    "52": "Bath with shower",
    "53": "WC",
    "55": "Baby bed",
    "56": "Option: baby chair",
    "58": "Radiators",
    "61": "Double bed",
    "63": "Option: baby bed and baby chair",
    "66": "Built-in wardrobes",
    "69": "Wardrobes",
    "70": "Night table",
    "71": "Night tables",
    "72": "Reading lamps",
    "73": "Desk",
    "74": "TV",
    "78": "Chest of drawers",
    "79": "Bathroom/WC",
    "81": "Bathroom",
    "82": "Bathrooms",
    "87": "Bedrooms",
    "89": "Balcony",
    "91": "Small terrace",
    "92": "Conservatory with dining table and chairs",
    "93": "Terraces",
    "94": "Kitchen in the living / dining room",
    "96": "Small Balcony",
    "97": "Hall",
    "98": "Corridor",
    "99": "Lounge",
    "100": "Terrace",
    "101": "Kitchen",
    "102": "Modern Kitchen",
    "106": "Bookcases",
    "110": "Cooking hob with an oven",
    "114": "Cooking hob",
    "115": "Oven",
    "118": "Modern style",
    "119": "Cooker",
    "123": "Electric kettle",
    "124": "Microwave",
    "125": "Toaster",
    "127": "Traditional",
    "128": "Plates",
    "129": "Pans",
    "130": "Fridge / freezer",
    "131": "Fridge",
    "133": "Mini ironing board",
    "134": "Washing machine with drier",
    "135": "Fully equipped kitchen",
    "137": "Clothes washer drier",
    "140": "Coffee maker",
    "142": "Dish rack",
    "143": "Vacuum cleaner",
    "144": "Tea pot",
    "146": "Gas/electric hob",
    "147": "Electric oven",
    "150": "Breakfast bar and stools",
    "151": "Kitchen table and chairs",
    "152": "Freezer",
    "157": "Kitchenette",
    "161": "Armchairs",
    "163": "Coffee table",
    "166": "TV (local channels only)",
    "167": "Satellite TV",
    "174": "Internet connection",
    "180": "Air conditioning",
    "181": "Air conditioning/heating",
    "182": "Sofa",
    "186": "Portable air conditioning unit",
    "187": "Heating",
    "188": "Lamp",
    "189": "Table and chairs",
    "192": "Leather sofa",
    "193": "Armchair and footstool",
    "197": "Shelves",
    "198": "Radio",
    "199": "Computer with free ASDL internet access",
    "200": "Double sofa bed",
    "201": "Wardrobe",
    "203": "Double sofa",
    "204": "Comfortable lounge on site",
    "205": "Help Desk",
    "208": "High Chairs",
    "209": "Extra Bed",
    "210": "Mattress",
    "215": "Airport Pick-up Service",
    "225": "Maid Service",
    "227": "Swimming pool",
    "231": "Weekly cleaning for free",
    "232": "Dry Cleaning & Laundry",
    "233": "Dry Cleaning",
    "234": "Laundry",
    "235": "Breakfast",
    "237": "Sofabed",
    "239": "Shower",
    "245": "Washbasin",
    "248": "Storage space",
    "249": "Living room",
    "250": "Dining table",
    "252": "Bath",
    "253": "Jacuzzi",
    "257": "Bedroom",
    "258": "Stove",
    "261": "Fan",
    "277": "Antique furniture",
    "281": "Wheelchair access possible",
    "294": "A Gym is in the building for guests to use",
    "295": "On street parking",
    "296": "Underground parking",
    "298": "Building attendant",
    "302": "Guarded parking",
    "308": "Telephone (incoming calls only)",
    "309": "Telephone (incoming and outgoing calls)",
    "311": "Dressing table",
    "312": "Fax Machine",
    "314": "Internet (computer supplied)",
    "315": "Bathtub",
    "320": "Separate entry",
    "321": "Separate bath",
    "322": "A door to the terrace",
    "323": "Single bed",
    "324": "King size bed",
    "325": "DVD player",
    "326": "CD selection",
    "327": "DVD selection",
    "328": "Floor heating",
    "330": "City maps",
    "331": "Full-stocked fridge",
    "332": "Brochures",
    "334": "FREE food and drinks",
    "336": "FREE fruits",
    "337": "FREE flower bouquets",
    "338": "FREE firewood for the fireplace",
    "339": "FREE internet access",
    "341": "Fine egyptian cotton sheets",
    "342": "Selection of food and drinks",
    "344": "Bathrobe",
    "345": "LCD panel",
    "346": "Garden",
    "347": "Large selection of luxury food, drinks, wines, coffees and teas",
    "348": "Fully stocked fridge with all thinkable fresh food, drink items",
    "349": "Wood burning fireplace",
    "351": "Large terry cloth bathtowels",
    "352": "\"Molton Brown\" amenities",
    "353": "Orchid plants",
    "354": "FREE international phoneline",
    "355": "Upon weekly stays: maidservice including personal laundry / ironing",
    "359": "Piano",
    "360": "Tumble dryer",
    "361": "Extractor Hood",
    "362": "Shared Kitchen, Living room and Garden with another quests",
    "363": "Armchair",
    "364": "Fireplace",
    "365": "Sauna",
    "368": "Free Wireless Internet",
    "371": "Home Theatre",
    "372": "Livingroom / Bedroom",
    "373": "Common Kitchen",
    "374": "Cell Phone Rentals",
    "375": "Fax and Photocopy Services",
    "376": "Coffee Pot",
    "379": "Digital Cable TV",
    "380": "Complimentary Tea & Coffee",
    "382": "Sidechairs",
    "384": "Bunk beds (sgl on top, dbl on bottom)",
    "385": "Cots, High Chairs, Mattress (on request)",
    "388": "Loft",
    "389": "Flat Screen Plasma TV",
    "390": "Espresso-Machine",
    "391": "Hot Tub",
    "395": "Towels",
    "396": "Alcove bedroom",
    "397": "End table",
    "404": "Health Club",
    "408": "BBQ grill",
    "409": "En suite bathroom",
    "412": "Walk in closet",
    "413": "Ice Maker",
    "414": "Dual wash basin",
    "415": "Spa pool",
    "417": "Free long distance phone calls",
    "418": "Video game system",
    "419": "Video game system w/games",
    "420": "Free use of 2-way radios",
    "421": "Game room",
    "422": "Initial toiletries",
    "426": "Telephone (incoming and local outgoing calls)",
    "428": "Armchair that can turn into a single bed",
    "429": "Computer rental",
    "432": "Sleeper chair",
    "433": "Free high speed wireless internet",
    "434": "Toilet/bidet",
    "435": "Gas stove",
    "436": "Blender",
    "437": "Hot plates",
    "438": "High speed Internet access",
    "439": "Dining room",
    "440": "Pair of twin beds",
    "444": "Bunk Bed",
    "445": "Big Screen TV",
    "446": "Complimentary Soap/Shampoo/Conditioner",
    "447": "Heated towel bar",
    "448": "Free weekly cleaning",
    "449": "River",
    "450": "Street",
    "451": "Courtyard",
    "452": "Square",
    "453": "Annex Room",
    "454": "Marble floor",
    "455": "2 single beds in the lounge",
    "456": "Chairs",
    "457": "Conservatory",
    "458": "Hydro-Massage Shower",
    "459": "Parquet floor",
    "460": "Sectional sofa",
    "461": "Business centre",
    "462": "State of the art appliances",
    "463": "Granite countertops",
    "464": "Custom cabinetry",
    "465": "Tennis Court",
    "466": "Day Care",
    "467": "Residence gym",
    "468": "LCD flat screen TV",
    "472": "Personal Shopping Service",
    "473": "Den",
    "476": "Skyline",
    "478": "Downtown",
    "479": "Golf Course",
    "480": "Widescreen TV",
    "481": "Wooden floor",
    "482": "Electric shaver",
    "483": "Wooden windows",
    "484": "Guide books",
    "485": "Queen size bed",
    "490": "Fan(s) on request",
    "491": "Iron/Ironing board on request",
    "497": "Luggage Storage Facilities",
    "499": "Hanger",
    "500": "Bookshelf",
    "501": "Day bed",
    "503": "Mirror",
    "504": "Private parking",
    "505": "Cloakroom",
    "506": "Cupboards",
    "507": "Table",
    "508": "Chair",
    "509": "Reading lamp",
    "510": "Lake",
    "511": "Sea",
    "512": "Ocean",
    "513": "Canal",
    "514": "Mezzanine",
    "515": "Wallbed",
    "516": "En suite shower",
    "517": "Bedroom/Living room with kitchen corner",
    "589": "Bed Linen",
    "590": "Iron",
    "591": "Ironing Board",
    "592": "Telephone",
    "593": "Computer",
    "594": "Canal view",
    "595": "Pets are welcome",
    "596": "Free cot in the apartment",
    "597": "Free cot on request",
    "598": "Concierge",
    "599": "Washer dryer",
    "600": "Dryer",
    "601": "Safe",
    "602": "Ski Storage",
    "603": "Mountain View",
    "604": "Seaview",
    "605": "Fitness Room",
    "606": "Spa",
    "607": "Steam room",
    "608": "Room Service",
    "609": "Slope View",
    "611": "Hot Tub (Private)",
    "612": "Hot Tub (Common)",
    "613": "Laundry (Private)",
    "614": "Laundry (Common)",
    "615": "Minibar",
    "616": "Doorman",
    "617": "Breakfast Room",
    "618": "Meeting Room",
    "619": "Restaurant",
    "620": "Bar",
    "621": "Beauty Salon",
    "622": "Children Area",
    "623": "Ski In and Out",
    "624": "Pull-Out Bed",
    "625": "Garden (Private)",
    "626": "Garden (Common)",
    "627": "Reception",
    "628": "Laundry Service",
    "629": "Adjoining Rooms",
    "630": "Outlet Adapters",
    "631": "Airline Desk",
    "632": "Meal Plan - American",
    "633": "ATM/Cash Machine",
    "634": "Audio Visual Equipment",
    "635": "Babysitting/Child Services",
    "636": "Barber Shop",
    "637": "On The Bay",
    "638": "Bay View",
    "639": "Meal Plan - Bed and Breakfast",
    "640": "Baby Listening Device",
    "641": "Beach View",
    "642": "Beach",
    "643": "Barber/Beauty Shop",
    "644": "Porters",
    "645": "Bicycle Rentals",
    "646": "Blackboard",
    "647": "Billiards / Pool Tables",
    "648": "Boating",
    "649": "Boutiques",
    "650": "Bowling",
    "651": "Meal Plan - Bermuda",
    "652": "Braille Elevator",
    "653": "Breakfast Buffet",
    "654": "Bathroom Telephone",
    "655": "Canopy / Poster Bed",
    "656": "Car Rental Desk",
    "657": "Casino",
    "658": "Castle Room",
    "659": "Meal Plan - Caribbean",
    "660": "CD Player",
    "661": "Ceiling Fan",
    "662": "City View",
    "663": "Conference Facilities",
    "664": "Conference Suite",
    "665": "Continental Breakfast",
    "666": "Coffee Shop",
    "667": "Coffee Maker in Room",
    "668": "Computer in Room",
    "669": "Concierge Desk",
    "670": "Connecting Rooms",
    "671": "Meal Plan - Continental",
    "672": "Copy Service",
    "673": "Cordless Phone",
    "674": "Cribs Available",
    "675": "Courtesy Car",
    "676": "City Center",
    "677": "Currency Exchange",
    "678": "Data port Available",
    "679": "24 Hour Front Desk",
    "680": "Dining Guide",
    "681": "Dinner",
    "682": "Handicapped Rooms/Facilities",
    "683": "Disco",
    "684": "Doctor on Call",
    "685": "Drugstore",
    "686": "Driving Range",
    "687": "Desk with lamp",
    "688": "Electronic Door Locks",
    "689": "Elevator",
    "690": "Email Service",
    "691": "Live Entertainment",
    "692": "Meal Plan - European",
    "693": "Express Check In",
    "694": "Executive Desk",
    "695": "Express Checkout",
    "696": "Executive Level",
    "697": "Meal Plan - FAP/Full-board",
    "698": "Full English Breakfast",
    "699": "Female Executive Rooms",
    "700": "Fishing",
    "701": "Florist",
    "702": "Free Parking",
    "703": "Free Local Telephone Calls",
    "704": "Free Transportation",
    "705": "Garden View",
    "706": "Gift Shop",
    "707": "Game Rental",
    "708": "Golf",
    "709": "Golf Course View",
    "710": "Horseback Riding",
    "711": "Jogging Track",
    "712": "Kennels",
    "713": "Childrens Activities",
    "714": "Lake View",
    "715": "Guest Laundromat",
    "716": "Lunch",
    "717": "Meal Plan - MAP/Half-board",
    "718": "Massage",
    "719": "Miniature Golf",
    "720": "In Room Movies",
    "721": "Meeting Facilities",
    "722": "Meeting Suite",
    "723": "Multilingual",
    "724": "Nursery for Children",
    "725": "No Smoking Rooms/Facilities",
    "726": "Night Club",
    "727": "Free Newspaper",
    "728": "News Stand",
    "729": "Ocean View",
    "730": "Overhead Projector",
    "731": "Parasailing",
    "732": "Park View",
    "733": "No Pets Allowed",
    "734": "Phone Service",
    "735": "Picnic Area/Tables",
    "736": "Play Ground",
    "737": "Heated Pool",
    "738": "Indoor Pool",
    "739": "Childrens Pool",
    "740": "Outdoor Pool",
    "741": "Poolside Snackbar",
    "742": "Projector",
    "743": "Squash",
    "744": "River View",
    "745": "Ramp Access to Buildings",
    "746": "24 Hour Room Service",
    "747": "Safe Deposit",
    "748": "Sailing",
    "749": "Scuba Diving",
    "750": "Secretarial Service",
    "751": "24 Hour Security",
    "752": "Shopping Mall",
    "753": "Free Airport Shuttle",
    "754": "Skeet Shooting",
    "755": "Skiing",
    "756": "Cross Country Skiing",
    "757": "Snorkeling",
    "758": "Snowboarding",
    "759": "Fitness Center or Spa",
    "760": "Steam Bath",
    "761": "Telex",
    "762": "Indoor Tennis",
    "763": "Tennis",
    "764": "Outdoor Tennis",
    "765": "Tour Desk",
    "766": "Translation Service",
    "767": "Laundry Services",
    "768": "Vending Machines",
    "769": "VIP Rooms/Services",
    "770": "Volleyball",
    "771": "Wake-up Service",
    "772": "Wedding Services",
    "773": "Wind Surfing",
    "774": "Water Skiing",
    "775": "Grab Bars in Bathroom",
    "776": "Heated Guest Rooms",
    "777": "Modem in Room",
    "778": "Murphy Bed",
    "779": "Rollaway Beds",
    "780": "Bathrobes",
    "781": "Smoke Detectors",
    "782": "Solarium",
    "783": "Sprinklers In Rooms",
    "784": "Theater Desk",
    "785": "Temperature Control",
    "786": "Trouser Press",
    "788": "Ipod Dock",
    "789": "Heating",
    "790": "Hi-Fi",
    "791": "Duty Free Shop",
    "792": "Wireless Internet",
    "793": "Parking",
    "794": "Outdoor Parking",
    "795": "Valet Parking",
    "796": "Prayer Mats",
    "797": "Racquetball Courts",
    "798": "Refrigerator",
    "799": "Smoking",
    "800": "Chef Provided",
    "801": "Marina View",
    "802": "Smoking allowed",
    "803": "Free parking on the street",
    "804": "Paid parking on the street",
    "805": "Free parking with garage",
    "806": "Paid parking with garage",
    "807": "Free cable internet",
    "808": "Paid cable internet",
    "809": "Paid wireless internet",
    "810": "Paid cot on request",
    "811": "Petanque",
    "812": "Ask for smoking",
    "813": "Ask for pets",
    "814": "Ask for accessibility",
    "815": "Communal pool",
    "816": "Private pool",
    "817": "Ping-pong table",
    "818": "Breakfast booking possible",
    "819": "House cleaning optional",
    "820": "Sports - swimming",
    "821": "Local hospital",
    "822": "Local groceries",
    "823": "Waterfront",
    "824": "Near ocean",
    "825": "Shared Kitchen",
    "826": "Shared Swimming Pool",
    "827": "Garage",
    "828": "Family/kids friendly",
    "829": "Laptop workspace",
    "830": "Juicer",
    "831": "Security camera at entrance",
    "832": "MP3",
    "833": "Baby cot",
    "834": "Gym",
    "835": "Paddle",
    "836": "Taxi access",
    "837": "Rooftop access",
    "838": "Baby high chair",
    "839": "Baby cot paid",
    "840": "Baby chair on request",
    "841": "High chair on request",
    "842": "Pets paid",
    "843": "Pets accepted under request",
    "844": "Stroller",
    "845": "Baby cutlery",
    "846": "Internet connection on request",
    "847": "Cable TV on request",
    "848": "Dry cleaning on request",
    "849": "Free international calls",
    "850": "Chimney",
    "851": "TV 3D",
    "852": "Smart TV",
    "853": "Free car",
    "854": "Free bike",
    "855": "Credit card payment accepted",
    "856": "No parties",
    "857": "No children under 4",
    "858": "No children under 12",
    "859": "Anyone under 25 years",
    "860": "Anyone under 30 years",
    "861": "Anyone under 35 years",
    "862": "Anyone under 18 years",
    "863": "No reservation more than 30 days",
    "864": "Groups under 18 years",
    "865": "Groups under 25 years",
    "866": "Groups under 30 years",
    "867": "Groups under 35 years",
    "868": "Only families",
    "869": "Anyone under 40 years",
    "870": "No children under 6",
    "871": "Groups under 50 years",
    "872": "Same sex groups under 30 years",
    "873": "Groups under 45 years",
    "874": "Same sex groups under 35 years",
    "875": "Arrivals on Sunday",
    "876": "Families or couples only",
    "877": "Baby high chair paid",
    "878": "Baby chair paid",
    "879": "Wifi USB Adapter",
    "880": "Bottled water",
    "881": "Centrally controlled ventilation",
    "882": "Electrical adapters available",
    "883": "Hypoallergenic rooms",
    "884": "Internet browser TV",
    "885": "Power converters",
    "886": "Sewing kit",
    "887": "Printer",
    "888": "Slippers",
    "889": "Sound system",
    "890": "Sound proofed windows",
    "891": "Weighting scale",
    "892": "Run of the house",
    "893": "Window",
    "894": "Veranda",
    "895": "Patio",
    "896": "AC public areas",
    "897": "Aqua sports center",
    "898": "Courier service",
    "899": "Creche",
    "900": "Housekeeping service",
    "901": "Entertainment recreation",
    "902": "Diving",
    "903": "Hair salon",
    "904": "Hotel shops",
    "905": "Island hopping",
    "906": "Jet skiing",
    "907": "Kids eat for free",
    "908": "Late check-out available",
    "909": "Limo town car service available",
    "910": "Security guard",
    "911": "Shoe shine",
    "912": "Shoe polishing machine",
    "913": "Shuttle service",
    "914": "Suitable for children",
    "915": "Ticket service",
    "916": "Turndown service",
    "917": "Umbrella",
    "918": "Welcome amenities",
    "919": "Country or rural view",
    "920": "Inland view",
    "921": "Panoramic view",
    "922": "Pool view",
    "923": "Village view",
    "924": "Valley view",
    "925": "Town view",
    "926": "Rare view",
    "927": "Loch view",
    "928": "Heated outdoor pool",
    "929": "Infants not allowed",
    "930": "Family friendly",
    "931": "Car necessary",
    "932": "Car recommended",
    "933": "Car not necessary",
    "934": "Romantic",
    "935": "Luxury",
    "936": "Budget",
    "937": "Water View",
    "938": "Beach chair",
    "939": "French bed",
    "940": "Toilet paper",
    "941": "Soap",
    "942": "Children not allowed",
    "943": "Carbon Monoxide Detector",
    "944": "Heated private pool",
    "945": "Table Football",
    "946": "Dartboard",
    "947": "Air Hockey Table",
    "948": "Basketball Hoop",
    "949": "Pool - Safety Fence",
    "950": "Patio Heater",
    "951": "Sun Loungers",
    "952": "External Lighting",
    "953": "Suitable for Elderly",
    "954": "Peaceful",
    "955": "Fire Extinguisher",
    "956": "Walk-in Shower",
    "957": "Tribunk bed",
    "958": "Minimarket on site",
    "959": "Adult only",
    "960": "Towels changed upon request",
    "961": "Room upgrade available upon availability",
    "962": "Guaranteed room upgrade",
    "963": "Free room upgrade available",
    "964": "Resort credit included",
    "965": "Welcome gift upon arrival",
    "966": "Eco friendly cleaning products",
    "967": "Gray water recycling",
    "968": "Renewable energy - geothermal",
    "969": "Renewable energy - solar",
    "970": "Renewable energy - wind",
    "971": "Essentials (towels, pillows, bed linen, soap, toilet paper)",
    "972": "Hangers",
    "973": "Hot water",
    "974": "Washer",
    "976": "Allergy free",
    "977": "Beach towels",
    "978": "Cleaning products",
    "979": "Earplugs",
    "980": "Lockers",
    "981": "Mosquito net",
    "984": "Private curtain",
    "985": "Room climate control",
    "986": "Restaurant guide",
    "987": "Self controlled heating / cooling system",
    "988": "Separate closet",
    "989": "Sun umbrellas",
    "990": "Trash cans",
    "991": "Electric vehicle charging station",
    "992": "Ironing service",
    "993": "Pet basket",
    "994": "Pet bowls",
    "995": "No single use plastics",
    "996": "No single use toiletries",
    "997": "Eligibility for hotel loyalty points",
    "998": "Beachfront",
    "999": "Garden or backyard",
    "1000": "Single level home",
    "1002": "Designated smoking area",
    "1003": "Detached",
    "1004": "Engawa sitting area",
    "1005": "Firepit",
    "1006": "Furnished balcony",
    "1007": "Furnished lanai",
    "1008": "Furnished patio",
    "1009": "Japanese garden",
    "1010": "Living plant wall",
    "1011": "Vegetable garden",
    "1012": "Gulf view",
    "1013": "Harbor view",
    "1014": "Hill view",
    "1015": "Lagoon view",
    "1016": "Lanai",
    "1017": "Landmark view",
    "1018": "Marina",
    "1019": "Multiple views",
    "1020": "No view",
    "1021": "Open air bath",
    "1022": "Outdoor dining area",
    "1023": "Outdoor fireplace",
    "1024": "Outdoor furniture",
    "1025": "Boat",
    "1026": "Outdoor entertainment area",
    "1027": "Water sports gear",
    "1028": "Partial lake view",
    "1029": "Partial view",
    "1030": "Porch",
    "1031": "Private flat in block of flats",
    "1032": "Quiet street view",
    "1033": "Resort view",
    "1034": "Semi detached",
    "1035": "Sun terrace",
    "1036": "Desert view",
    "1037": "Partial ocean view",
    "1038": "Partial sea view",
    "1039": "Vineyard view",
    "1040": "1 game drive per night",
    "1041": "2 game drives per night",
    "1042": "Bingo",
    "1043": "Board games/puzzles",
    "1044": "Books",
    "1045": "Casino credit",
    "1046": "Casino nearby",
    "1047": "Concerts or live performances",
    "1048": "Cooking class",
    "1049": "Disney park tickets",
    "1050": "Entertainment staff",
    "1051": "Evening entertainment",
    "1052": "Fitness classes",
    "1053": "Fitness facilities",
    "1054": "Fitness facilities nearby",
    "1055": "Fitness spa locker rooms",
    "1056": "Foot bath",
    "1057": "Free water park passes",
    "1058": "Happy hour",
    "1059": "Hot springs nearby",
    "1060": "Hot springs onsite",
    "1061": "Indoor publicbath no mineral springs",
    "1062": "Infinity pool",
    "1063": "Jetted tub",
    "1064": "Karaoke",
    "1065": "Leisure gambling",
    "1066": "Library",
    "1067": "Live sports events broadcast",
    "1068": "Massage chair",
    "1069": "Match play",
    "1070": "Mineral hot springs indoor",
    "1071": "Mineral hot springs outdoor",
    "1072": "Movie nights",
    "1073": "Outdoor public bath - no mineral springs",
    "1074": "Personal trainer available",
    "1075": "Plunge pool",
    "1076": "Pool bar",
    "1077": "Pool cover",
    "1078": "Pool towels",
    "1079": "Pool with view",
    "1080": "Pool above ground",
    "1081": "Pool cabanas",
    "1083": "Pool in ground",
    "1084": "Pool sun loungers",
    "1085": "Pool umbrellas",
    "1086": "Pool waterfall",
    "1087": "Private beach area",
    "1088": "Pub crawls",
    "1089": "Public bath",
    "1090": "Rooftop pool",
    "1091": "Art supplies",
    "1092": "Musical instruments",
    "1093": "Private mineral hot springs - indoor",
    "1094": "Private mineral hot springs - outdoor",
    "1095": "Salt water pool",
    "1096": "Shallow end pool",
    "1097": "Slot play",
    "1098": "Stand up comedy",
    "1099": "Swim up bar",
    "1100": "Swimming pool toys",
    "1101": "Telescope",
    "1102": "Temporary art galleries",
    "1103": "Themed dinner nights",
    "1104": "Tour or class about local culture",
    "1105": "Trampoline",
    "1106": "Walking tours",
    "1107": "Waterslide",
    "1108": "Whirpool",
    "1109": "Winery",
    "1110": "Winery private tours onsite",
    "1111": "Winery public tours onsite",
    "1112": "Winery release events onsite",
    "1113": "Winery tasting room onsite",
    "1114": "Winery tours nearby",
    "1115": "Winery vineyard onsite",
    "1116": "Yoga classes",
    "1117": "Golf credit",
    "1118": "Shopping",
    "1119": "Ice skating nearby",
    "1120": "Ice skating onsite",
    "1121": "Aerobics",
    "1122": "Archery onsite",
    "1123": "Theme parks",
    "1124": "Badminton equipment",
    "1125": "Near private beach direct access",
    "1126": "Near public beach direct access",
    "1127": "Beach cabanas",
    "1128": "Beach volleyball onsite",
    "1129": "Beach yoga onsite",
    "1130": "Bike tours",
    "1131": "Biking on road nearby",
    "1132": "Birdwatching nearby",
    "1133": "Birdwatching onsite",
    "1134": "Canoe onsite",
    "1135": "Boat onsite",
    "1136": "Inflatable boat onsite",
    "1137": "Kayak onsite",
    "1138": "Pedal boat onsite",
    "1139": "Sailboat onsite",
    "1140": "Boat tours nearby",
    "1141": "Boat tours onsite",
    "1142": "Cave exploring nearby",
    "1143": "Cave exploring onsite",
    "1144": "Cycling",
    "1145": "Ecotours nearby",
    "1146": "Ecotours onsite",
    "1147": "Farming classes",
    "1148": "Fish cleaning table",
    "1149": "Game drive nearby",
    "1150": "Game drive onsite",
    "1151": "Game or wildlife walk nearby",
    "1152": "Game or wildlife walk onsite",
    "1153": "Game viewing nearby",
    "1154": "Game viewing onsite",
    "1155": "Golf caddy",
    "1156": "Golf cart",
    "1157": "Golf clubhouse",
    "1158": "Golf equipment",
    "1159": "Golf course without driving range",
    "1160": "Golf pro shop",
    "1161": "Helicopter or plane tours onsite",
    "1162": "Hiking",
    "1163": "Hiking biking nearby",
    "1164": "Hiking biking onsite",
    "1165": "Hunting nearby",
    "1166": "Hunting onsite",
    "1167": "Kayaking nearby",
    "1168": "Kayaking onsite",
    "1169": "Lazy river",
    "1170": "Motor boat nearby",
    "1171": "Motor boat onsite",
    "1172": "Mountain climbing nearby",
    "1173": "Personal watercraft nearby",
    "1174": "Personal watercraft onsite",
    "1175": "Rafting nearby",
    "1176": "Rafting onsite",
    "1177": "Ropes course team building onsite",
    "1178": "Rowing or canoeing onsite",
    "1179": "Safari nearby",
    "1180": "Safari onsite",
    "1181": "Scuba diving nearby",
    "1182": "Skydiving nearby",
    "1183": "Skydiving onsite",
    "1184": "Snorkeling nearby",
    "1185": "Surfing or boogieboarding nearby",
    "1186": "Surfing or boogieboarding onsite",
    "1187": "Tennis equipment",
    "1188": "Tennis lessons onsite",
    "1189": "Walkway to water",
    "1191": "Water park",
    "1192": "Water skiing nearby",
    "1193": "Water tubing nearby",
    "1194": "Windsurfing nearby",
    "1195": "Ziplining nearby",
    "1196": "Ziplining onsite",
    "1197": "Beach sand type: sand",
    "1198": "Beach sand type: black sand",
    "1199": "Beach sand type: white sand",
    "1201": "Accessible height toilet",
    "1202": "Bathroom step free access",
    "1203": "Bathroom wide doorway",
    "1204": "Bedroom step free access",
    "1205": "Bedroom wide doorway",
    "1206": "Ceiling hoist",
    "1207": "Common space step free access",
    "1208": "Common space wide doorway",
    "1209": "Parking spot for disabled",
    "1210": "Electric profiling bed",
    "1211": "First aid kit",
    "1212": "Handheld shower head",
    "1213": "Home step free access",
    "1214": "Home wide doorway",
    "1215": "Lock on bedroom door",
    "1216": "Mobile hoist",
    "1217": "Path to entrance lit at night",
    "1218": "Pool hoist",
    "1219": "Private entrance",
    "1220": "Rollin shower",
    "1221": "Shower chair",
    "1222": "Tub with shower bench",
    "1223": "Wide clearance to bed",
    "1224": "Wide clearance to shower and toilet",
    "1225": "Wide hallway clearance",
    "1226": "Accessible bathroom",
    "1227": "Accessible parking",
    "1228": "Accessible path of travel",
    "1229": "Adapted bath",
    "1230": "Auditory guidance",
    "1231": "Bathroom emergency pull cord",
    "1232": "Bed rails",
    "1233": "Cabinet locks",
    "1234": "Corner guards",
    "1235": "Electronic key card access",
    "1237": "Entire property on ground floor",
    "1238": "Equipment for deaf",
    "1239": "Laptop safe box",
    "1240": "Low bathroom sink",
    "1241": "Medical emergency contact",
    "1242": "Metal keys access",
    "1243": "Police emergency contact",
    "1244": "Room safety pool gate",
    "1245": "Safe large enough to accommodate a laptop",
    "1246": "Room safety security system",
    "1248": "Upper floor reachable by stairs only",
    "1249": "Visual aids: braille",
    "1250": "Visual aids: tactile signs",
    "1251": "Window guards",
    "1252": "Safety: balcony warning",
    "1253": "Safety: fully fenced property",
    "1254": "Chapel or shrine",
    "1255": "Family rooms",
    "1256": "Bridal suite",
    "1257": "Soundproof rooms",
    "1258": "2 bathrooms",
    "1259": "Ensuite",
    "1260": "Private bathroom",
    "1261": "Shared bathroom",
    "1262": "Full kitchen",
    "1263": "Dressing room",
    "1264": "Interconnecting room(s) available",
    "1265": "Large desk",
    "1266": "Sitting area",
    "1267": "Desk with electrical outlet",
    "1268": "Closets in room",
    "1269": "Chair provided with desk",
    "1270": "Dining room seats",
    "1271": "Multiple closets",
    "1272": "Seating area",
    "1273": "Carpeted floor",
    "1274": "Dining area",
    "1276": "Clothes rack",
    "1277": "Room decor",
    "1278": "Cleaning before checkout",
    "1282": "Housekeeping daily",
    "1283": "Housekeeping once per stay",
    "1284": "Housekeeping weekends only",
    "1285": "Housekeeping weekdays only",
    "1286": "Room service limited",
    "1287": "Room service generic",
    "1288": "2 for 1 buffet",
    "1289": "All meals",
    "1290": "All inclusive",
    "1291": "Beach bar",
    "1292": "Breakfast for 1",
    "1293": "Breakfast for 2",
    "1294": "Breakfast in the room",
    "1295": "Chocolate cookies",
    "1296": "Coffee tea maker",
    "1297": "Complimentary wine reception",
    "1298": "Continental breakfast for 2",
    "1299": "Couples dining",
    "1300": "Drinks and hors doeuvres",
    "1301": "Food beverage credit",
    "1302": "Free breakfast for 1 adult",
    "1303": "Free dinner for 1 adult",
    "1304": "Free welcome drink",
    "1305": "Full board",
    "1306": "Grocery store",
    "1307": "Half board",
    "1308": "Mini refrigerator",
    "1309": "On site coffee house",
    "1310": "Packed lunches",
    "1311": "Refrigerator with ice maker",
    "1312": "In-room dining only",
    "1313": "Snack bar",
    "1314": "Special diet menus on request",
    "1315": "Tea service",
    "1319": "Wine glasses",
    "1320": "Wine champagne",
    "1321": "Baby bath",
    "1322": "Changing table",
    "1323": "Childrens books and toys",
    "1324": "Childrens dinnerware",
    "1325": "Fireplace guards",
    "1326": "Outlet covers",
    "1327": "Room darkening shades",
    "1328": "Stair gates",
    "1329": "Table corner guards",
    "1330": "Baby safety gates",
    "1331": "Board games puzzles",
    "1332": "Book dvd music library for children",
    "1333": "Children television networks",
    "1334": "Childrens games",
    "1335": "Entertainment toys",
    "1336": "Indoor play area",
    "1337": "Infant toddler toys",
    "1338": "Kid meals",
    "1339": "Kids outdoor play equipment",
    "1340": "Child dishware",
    "1341": "Childcare",
    "1342": "Child size slippers",
    "1344": "Extra large double",
    "1345": "Extra long beds 2 meter",
    "1346": "Futon mat",
    "1347": "Large double",
    "1348": "Down comforter",
    "1349": "Hypo bed available",
    "1350": "Accessible height bed",
    "1352": "Cooking basics",
    "1353": "Kitchen supplies",
    "1354": "Kitchen dining area",
    "1355": "Kitchenware",
    "1356": "Microwave shared not in room",
    "1357": "Refrigerator microwave",
    "1358": "Coffee grinder",
    "1359": "Griddle",
    "1360": "Lobster pot",
    "1361": "Mixer",
    "1362": "Spices",
    "1363": "Stovetop",
    "1364": "Waffle maker",
    "1366": "Entertainment video library",
    "1367": "Free movies / video",
    "1368": "Pay per view movies on tv",
    "1369": "List of movie channels available",
    "1370": "cnn available",
    "1371": "Bluray player",
    "1372": "Pay per view channels",
    "1373": "First run movies",
    "1374": "Premium tv channels",
    "1375": "Streaming service such as netflix",
    "1376": "Video on demand",
    "1377": "Includes one free in room movie",
    "1378": "Laptop",
    "1379": "Telephone tdd textphone",
    "1380": "Multi line phone",
    "1381": "Telephone for hearing impaired",
    "1382": "Two-line phone",
    "1383": "Satellite radio",
    "1384": "Mobile / cellular phones available",
    "1385": "Ipad",
    "1386": "Game console xbox 360",
    "1387": "Game console playstaytion 2",
    "1388": "Game console playstation 3",
    "1389": "Game console nintendo wii",
    "1390": "Game console xbox one",
    "1391": "Game console wii u",
    "1392": "Game console playstation 4",
    "1393": "Smartphone available",
    "1394": "Electric vehicle charger",
    "1395": "Tour assistance",
    "1396": "Frette italian sheets",
    "1397": "Premium mattress",
    "1398": "Business lounge access",
    "1399": "Free calls available",
    "1400": "Champagne service",
    "1401": "Luxury tents",
    "1402": "Free fitness center access",
    "1403": "Free business center access",
    "1404": "Vip line access to nightclub(s)",
    "1406": "Bath linens",
    "1407": "Bath tub with spray jets",
    "1408": "Bathtub only",
    "1409": "Grecian tub",
    "1410": "Shower only",
    "1411": "Bathtub and whirlpool separate",
    "1412": "Oversized bathtub",
    "1413": "Separate tub and shower",
    "1414": "Separate toilet area",
    "1415": "Spa bath",
    "1417": "Guest toilet",
    "1418": "Additional toilet",
    "1419": "Additional bathroom",
    "1420": "Toothbrush",
    "1421": "Shower cap",
    "1422": "Shared bathroom with sink",
    "1424": "Outdoor partially open bathroom",
    "1425": "Child size bathrobes",
    "1426": "Electronic bidet",
    "1427": "Designer toiletries",
    "1428": "Geta sandals",
    "1429": "Private spa tub",
    "1430": "Deep soaking bathtub",
    "1431": "Spring water room bathtub",
    "1432": "Baby bath with rainfall showerhead",
    "1433": "Paper towels",
    "1434": "Hair dryer on request",
    "1435": "Laundry detergent",
    "1436": "Bed linens",
    "1437": "Extra pillows and blankets",
    "1438": "Electric blankets",
    "1439": "Pajamas",
    "1440": "Yukata",
    "1441": "Socket near the bed",
    "1442": "Feather pillows",
    "1443": "Non feather pillows",
    "1444": "Hypoallergenic pillows",
    "1445": "Pillow menu",
    "1446": "Ski lift privileges optional",
    "1447": "Snowboarding onsite",
    "1448": "Sledding nearby",
    "1449": "Sledding onsite",
    "1450": "Snow tubing nearby",
    "1451": "Snow tubing onsite",
    "1452": "Snowmobiling nearby",
    "1453": "Snowmobiling onsite",
    "1454": "Snowshoeing nearby",
    "1455": "Snowshoeing onsite",
    "1456": "Ski area nearby",
    "1457": "Ski lifts nearby",
    "1458": "Ski runs nearby",
    "1459": "Ski lessons nearby",
    "1460": "Ski lessons onsite",
    "1461": "Ski lift privileges",
    "1462": "Ski passes",
    "1463": "Ski rentals nearby",
    "1464": "Ski rentals onsite",
    "1465": "Snow sports gear",
    "1466": "Downhill nearby",
    "1467": "Downhill onsite",
    "1468": "Ski school",
    "1469": "Ski equipment hire on site",
    "1470": "Ski pass vendor",
    "1471": "Ski shuttle",
    "1472": "Ski to door access",
    "1473": "Free ski lift ticket rental",
    "1475": "Ski shuttle nearby",
    "1476": "Spa communal pool",
    "1477": "Spa hot tub",
    "1478": "Spa private pool",
    "1479": "Aromatherapy",
    "1480": "Ayurvedic",
    "1481": "Body scrubs",
    "1483": "Body wraps",
    "1485": "Hydrotherapy",
    "1486": "Couples spa rooms",
    "1487": "Outdoor treatment area",
    "1488": "Thalassotherapy",
    "1489": "Turkish bath",
    "1490": "Detoxification wrap",
    "1491": "Reflexology",
    "1492": "Hot springs",
    "1493": "Sauna in spa",
    "1494": "Mud bath in spa",
    "1495": "Spa tub in spa",
    "1496": "Steam room in spa",
    "1497": "Manicure pedicure",
    "1498": "Pilates onsite",
    "1499": "Massage - advanced booking required",
    "1500": "Beach massage",
    "1501": "Deep tissue massage",
    "1502": "Hot stone massage",
    "1503": "Prenatal massage",
    "1504": "Sports massage",
    "1505": "Swedish massage",
    "1506": "Thai massage",
    "1507": "Spa facilities",
    "1508": "Spa lounge relaxation area",
    "1509": "Spa wellness packages",
    "1510": "Back massage",
    "1511": "Neck massage",
    "1512": "Foot massage",
    "1513": "Couples massage",
    "1514": "Head massage",
    "1515": "Hand massage",
    "1516": "Full body massage",
    "1517": "Hair dresser beautician",
    "1518": "Facial treatments",
    "1519": "Waxing services",
    "1520": "Make up services",
    "1521": "Hair treatments",
    "1522": "Manicure",
    "1523": "Pedicure",
    "1524": "Hair cut",
    "1525": "Hair colouring",
    "1526": "Hair styling",
    "1527": "Body treatments",
    "1528": "Body scrub",
    "1529": "Light therapy",
    "1530": "Spa credit",
    "1538": "Accommodations other services car available",
    "1539": "Electric car charging station",
    "1540": "Scooter or moped rental nearby",
    "1541": "Scooter or moped rental onsite",
    "1542": "Airport shuttle service surcharge",
    "1543": "Public transport tickets",
    "1544": "Private check in check out",
    "1545": "Free return airport transfer",
    "1546": "Parking limited spaces available",
    "1547": "Segway tour nearby",
    "1548": "Segway tour onsite",
    "1549": "Airport shuttle drop off free",
    "1550": "Airport shuttle drop off at surcharge",
    "1551": "Airport shuttle pickup free",
    "1552": "Airport shuttle pickup at surcharge",
    "1553": "Airport shuttle roundtrip free",
    "1554": "Airport shuttle time roundtrip at surcharge",
    "1555": "Airport shuttle time generic",
    "1556": "Airport shuttle time available 24hours",
    "1557": "Airport shuttle time no shuttle",
    "1558": "Airport shuttle - limited hours",
    "1559": "Airport shuttle - time available on request",
    "1560": "Airport shuttle fee adult available during scheduled times",
    "1561": "Airport shuttle fee adult contact property prior to arrival",
    "1562": "Airport shuttle fee adult fee amt",
    "1563": "Area shuttle free",
    "1564": "Area shuttle distance surcharge",
    "1565": "Area shuttle distance generic",
    "1566": "Beach shuttle free",
    "1567": "Beach shuttle surcharge",
    "1568": "Shopping center shuttle free",
    "1569": "Shopping center shuttle surcharge",
    "1570": "Casino shuttle free",
    "1571": "Casino shuttle surcharge",
    "1572": "Theme park shuttle free",
    "1573": "Theme park shuttle surcharge",
    "1574": "Cruise terminal shuttle free",
    "1575": "Cruise terminal shuttle surcharge",
    "1576": "Ferry terminal shuttle surcharge",
    "1577": "Ferry terminal shuttle contact property prior to arrival",
    "1578": "Ferry terminal shuttle free",
    "1579": "Train station pickup service surcharge",
    "1580": "Train station pickup service contact property prior to arrival",
    "1581": "Train station pickup service free",
    "1582": "Train shuttle time surcharge",
    "1583": "Train shuttle time available 24hours",
    "1584": "Train shuttle time available during scheduled times",
    "1585": "Train shuttle time available limited hours",
    "1586": "Train shuttle time available on request",
    "1587": "Must contact property for pickup drop off free",
    "1588": "Must contact property for pickup drop off surcharge",
    "1589": "Must contact property for pickup onarrival",
    "1590": "Must contact property for pickup 24 hours prior to arrival",
    "1592": "Must contact property for pickup 48 hours prior to arrival",
    "1593": "Must contact property for pickup 72 hours prior to arrival",
    "1594": "Dining snack bar or deli",
    "1595": "Childrens menu",
    "1596": "Cuisine afghan",
    "1597": "Cuisine african",
    "1598": "Cuisine american",
    "1599": "Cuisine argentinean",
    "1600": "Cuisine asian",
    "1601": "Cuisine barbecue",
    "1602": "Cuisine basque",
    "1603": "Cuisine belgian",
    "1604": "Cuisine brazilian",
    "1605": "Cuisine british",
    "1606": "Cuisine burmese",
    "1607": "Cuisine cajun or creole",
    "1608": "Cuisine californian",
    "1609": "Cuisine cambodian",
    "1610": "Cuisine caribbean",
    "1611": "Cuisine chinese",
    "1612": "Cuisine cuban",
    "1613": "Cuisine dim sum",
    "1614": "Cuisine eastern european",
    "1615": "Cuisine eritrean",
    "1616": "Cuisine ethiopian",
    "1617": "Cuisine filipino",
    "1618": "Cuisine fish and chips",
    "1619": "Cuisine fondue",
    "1620": "Cuisine french",
    "1621": "Cuisine fusion",
    "1622": "Cuisine german",
    "1623": "Cuisine greek",
    "1624": "Cuisine halal",
    "1625": "Cuisine hawaiian",
    "1626": "Cuisine himalayan",
    "1627": "Cuisine hungarian",
    "1628": "Cuisine indfivesian",
    "1629": "Cuisine indian",
    "1630": "Cuisine international",
    "1631": "Cuisine irish",
    "1632": "Cuisine italian",
    "1633": "Cuisine japanese",
    "1634": "Cuisine korean",
    "1635": "Cuisine kosher",
    "1636": "Cuisine laotian",
    "1637": "Cuisine live or raw",
    "1638": "Cuisine local",
    "1639": "Cuisine local and international",
    "1640": "Cuisine malaysian",
    "1641": "Cuisine mediterranean",
    "1642": "Cuisine mexican",
    "1643": "Cuisine middle eastern",
    "1644": "Cuisine modern european",
    "1645": "Cuisine mongolian",
    "1646": "Cuisine moroccan",
    "1647": "Cuisine pakistani",
    "1648": "Cuisine pan asian",
    "1649": "Cuisine persian iranian",
    "1650": "Cuisine peruvian",
    "1651": "Cuisine pizza",
    "1652": "Cuisine polish",
    "1653": "Cuisine portuguese",
    "1654": "Cuisine regional",
    "1655": "Cuisine russian",
    "1656": "Cuisine scandinavian",
    "1657": "Cuisine seafood",
    "1658": "Cuisine singaporean",
    "1659": "Cuisine soul food",
    "1660": "Cuisine southern",
    "1661": "Cuisine spanish",
    "1662": "Cuisine sushi",
    "1663": "Cuisine taiwanese",
    "1664": "Cuisine tex mex",
    "1665": "Cuisine thai",
    "1666": "Cuisine turkish",
    "1667": "Cuisine ukrainian",
    "1668": "Cuisine vegan",
    "1669": "Cuisine vegetarian",
    "1670": "Cuisine vietnamese",
    "1671": "Has bar",
    "1672": "Location al fresco",
    "1673": "Location beachfront",
    "1674": "Location garden view",
    "1675": "Location golf view",
    "1676": "Location ocean view",
    "1677": "Location pool view",
    "1678": "Location poolside",
    "1680": "Brunch",
    "1683": "Light fare",
    "1685": "Reservations required",
    "1686": "Bistro",
    "1687": "Brasserie",
    "1688": "Buffet",
    "1689": "Cafe",
    "1691": "Delicatessen",
    "1692": "Diner",
    "1693": "Family restaurant",
    "1694": "Fine dining",
    "1695": "Pub",
    "1697": "Seafood",
    "1698": "Steakhouse",
    "1699": "Sushi bar",
    "1700": "Tapas",
    "1701": "Theme",
    "1702": "Adventure sport property theme",
    "1703": "Beach property theme",
    "1704": "Business property theme",
    "1705": "Casino property theme",
    "1706": "Family property theme",
    "1707": "Golf property theme",
    "1708": "Hot springs property theme",
    "1709": "Ski property theme",
    "1710": "Spa property theme",
    "1711": "Romantic property theme",
    "1712": "Winery property theme",
    "1713": "City property theme",
    "1714": "Natural property theme",
    "1715": "Shopping property theme",
    "1716": "Property design baroque",
    "1717": "Property design beaux arts",
    "1718": "Property design belle epoque",
    "1719": "Property design colonial",
    "1720": "Property design deco",
    "1721": "Property design edwardian",
    "1722": "Property design georgian",
    "1723": "Property design mediterranean",
    "1724": "Property design traditional",
    "1725": "Property design tudor",
    "1726": "Property design tuscan",
    "1727": "Property design victorian",
    "1728": "Parking reservation required",
    "1729": "Internet coverage public areas",
    "1730": "Internet coverage all rooms",
    "1731": "Internet coverage some rooms",
    "1732": "Internet coverage business centre",
    "1733": "Parties allowed",
    "1734": "Courtyard view",
    "1735": "Smoking not allowed",
    "1736": "Suitable for infants",
    "1741": "Guest ID required on check-in",
    "1742": "Guests with tattoos not allowed",
    "1743": "Pedestrian zone only",
    "1744": "Access by unpaved road",
    "1745": "Residential area",
    "1746": "Busy area",
    "1747": "Guest Identification Required",
    "1748": "Tattoos Not Allowed",
    "1749": "Pedestrian Zone",
    "1750": "Unpaved Road Access",
    "1751": "Residential Area",
    "1752": "Busy Area",
    "1753": "Enhanced cleaning practices",
    "1754": "Cleaning by professional cleaning companies",
    "1755": "Disinfectants used for cleaning",
    "1756": "Cleaning chemicals that are effective against Coronavirus used",
    "1757": "Social distancing following guidelines from local authorities",
    "1758": "Process in place to check guests' health",
    "1759": "Faces masks available",
    "1760": "Hand sanitizer available",
    "1761": "Screens or physical barriers placed between staff and guests in appropriate areas",
    "1762": "Contactless check-in and checkout is available.",
    "1763": "Contactless check-in available",
    "1764": "Contactless check-out available",
    "1765": "Staff follow all safety protocols from local authorities",
    "1766": "Linens, towels and laundry washed in accordance with local authorities guidelines",
    "1767": "Linen and towels washed in at least 60°C/140°F",
    "1768": "Plates, cutlery, glasses and other tableware sanitised",
    "1769": "High touch surfaces disinfected",
    "1770": "Guest accommodation sealed after cleaning",
    "1771": "Guest accommodation cleaning can be avoided on request",
    "1772": "Staff wear personal protective equipment",
    "1773": "Temperature checks on staff",
    "1774": "Property is vacant for at least 24 hours between reservations.",
    "1775": "Property is vacant for at least 48 hours between reservations.",
    "1776": "Property is vacant for at least 72 hours between reservations.",
    "1777": "Additional COVID-19 related documentation required",
    "1778": "Guests from certain countries not allowed",
    "1779": "Gloves available to guests",
    "1780": "Shared stationery printed menus, pens, paper removed",
    "1781": "First aid kit available",
    "1782": "Cashless payment available",
    "1783": "Property available for essential COVID-19 travellers only",
    "1784": "Reduced hours of service",
    "1785": "Spa & Gym not available",
    "1786": "Services on site reduced",
    "1787": "Shuttle service suspended",
    "1788": "Social distancing in dining areas",
    "1789": "In-room dining options available",
    "1790": "Reduced food services",
    "1791": "Individually-wrapped food for breakfast",
    "1792": "Individually-wrapped food for lunch",
    "1793": "Individually-wrapped food for dinner",
    "1794": "Individually-wrapped food at room service",
    "1795": "Mobile app for room service",
    "1796": "Singapore SG Clean sanitization protocol followed",
    "1797": "Malaysia Safe & Clean sanitization protocol followed",
    "1798": "South Korea CESCO sanitization protocol followed",
    "1799": "Thailand Safety and Health Administration sanitization protocol followed",
    "1801": "Portugal Clean & Safe sanitization protocol followed",
    "1802": "Spain Ministry of Indurstry, Trade & Tourism sanitization protocol followed",
    "1803": "Spain Confederación Española de Hoteles y Alojamientos Turísticos sanitization protocol followed",
    "1804": "Italy Federalberghi National Protocol Accoglienza Sicura (Safe Hospitality) sanitization protocol followed",
    "1805": "Brazil Protected Tourist sanitization protocol followed",
    "1807": "Property follows sanitization practices of Sanitary Protocol (UNPLV - France)",
    "1809": "Property follows sanitization practices of SafeStay (AHLA - USA) ",
    "1810": "Property follows guide to reopening vacation rentals (DTV & DFV - Germany)",
    "1811": "Property follows sanitization practices of European Holiday Home Association (EHHA - Europe)",
    "1812": "Property follows sanitization practices of Intertek Cristal (3rd party expert - Global)",
    "1813": "Property follows sanitization practices of Safe Travels (WTTC - Global)",
    "1814": "Property follows sanitization practices of Croatian Tourism Association (HUT - Croatia)",
    "1815": "Property follows sanitization practices of SafeHome (VRMA & VRHP)",
    "1817": "In-person check-in",
    "1818": "Lockboxes & Key Safes check-in",
    "1819": "Keypad check-in",
    "1820": "Guest should contact us for instructions",
    "1821": "Washer - common space",
    "1822": "Dryer - common space",
    "1823": "Travel crib",
    "1825": "Double futon",
    "1826": "Airbnb: Everyone can make instant booking",
    "1827": "Airbnb: Well reviewed guest can make instant booking",
    "1828": "Airbnb: Guests with verified identity can make instant booking",
    "1829": "Airbnb: Only well reviewed guests with verified identity can make instant booking",
    "1830": "Stairs",
    "1831": "Potential noise",
    "1832": "Pets on property",
    "1833": "Limited parking",
    "1834": "Shared spaces",
    "1835": "Limited amenities",
    "1836": "Weapons on property",
    "1837": "Dangerous animals",
    "1838": "Conditioner",
    "1839": "Rain shower",
    "1840": "Shower gel",
    "1841": "Any of the following: wardrobe, wardrobes, separate closet",
    "1842": "Exercise equipment",
    "1843": "Record player",
    "1844": "Baking sheet",
    "1845": "Bread maker",
    "1846": "Coffee",
    "1847": "Rice maker",
    "1848": "Trash compactor",
    "1849": "Laundromat nearby",
    "1850": "Resort access",
    "1851": "Boat slip",
    "1852": "Hammock",
    "1853": "Outdoor seating",
    "1854": "Outdoor kitchen",
    "1855": "Paid parking on premises",
    "1856": "Long term stays",
    "1857": "Bathroom shared with other guests",
    "1858": "Bathroom shared with the host",
    "1859": "Bathroom shared with family, friends, roommates",
    "1860": "Common spaces shared with other guests",
    "1861": "Common spaces shared with the host",
    "1862": "Common spaces shared with family, friends, roommates",
    "1863": "Surveillance cameras on property",
    "1864": "Fitness Equipment",
    "1865": "Air mattress",
    "1866": "Floor mattress",
    "1867": "BBQ gas",
    "1868": "BBQ charcoal",
    "1869": "Location ocean front",
    "1870": "Chef Fee",
    "1871": "Chef On Request",
    "1873": "Max 1 pet allowed",
    "1874": "Max 2 pets allowed",
    "1875": "Max 3 pets allowed",
    "1876": "Max 4 pets allowed",
    "1877": "Max 5 pets allowed",
    "1878": "Checkout task: Return keys on checking out",
    "1879": "Checkout task: Turn lights/appliances etc off on leaving",
    "1880": "Checkout task: Take care of trash before leaving",
    "1881": "Checkout task: Lock the doors on leaving",
    "1882": "Checkout task: Keep the towels in a specified place",
    "1883": "Checkout task: Turn off lights and air conditioning",
    "1884": "Checkout task: Turn off fans and electronics",
    "1885": "Checkout task: Turn off lights and close windows",
    "1886": "Checkout task: Lock windows and doors",
    "1887": "Checkout task: Lock up and return key",
    "1888": "Checkout task: Lock door and balcony and return key",
    "1889": "Checkout task: Gather towels and linens in linen bag",
    "1890": "Checkout task: Leave towels in the bathroom",
    "1891": "Checkout task: Gather towels and linens",
    "1892": "Checkout task: Clean dishes",
    "1893": "Checkout task: Remove food from the refrigerator",
    "1894": "Checkout task: Empty out the trash and start the dishwasher",
    "1895": "Checkout task: Unclean property will cause cleaning fee",
    "1897": "Checkout task: Dispose of trash in bins or dumpsters",
    "1898": "Checkout task: Recycling instructions",
    "1899": "Checkout task: Trash chutes on specific floors",
    "1900": "Checkout task: Bins/dumpsters outside the property",
    "1901": "Checkout task: Disposal methods in house manual",
    "1902": "Checkout task: Leave keys on the table",
    "1904": "Checkout task: Leave keys in the lockbox",
    "1905": "Checkout task: Leave keys in the key safe",
    "1906": "Checkout task: Leave keys in the kitchen",
    "1907": "Checkout task: Leave keys with staff or security",
    "1908": "Service animals only",
    "1909": "Bicycle parking"
};

window.__pt.ln.amenityaccommodation = {
    "2": "Cookware & Kitchen Utensils",
    "3": "Crockery & Cutlery",
    "4": "Iron & Ironing Board",
    "5": "Drying Rack",
    "6": "Hair Dryer",
    "7": "Bed Linen & Towels",
    "8": "Toiletries",
    "9": "Central Heating",
    "11": "Washing Machine",
    "13": "Dishwasher",
    "17": "Kettle",
    "19": "Cable TV",
    "21": "Alarm Clock",
    "22": "Stereo",
    "23": "DVD",
    "24": "CD player",
    "25": "Video (VHS) Player",
    "27": "There is also a second separate toilet",
    "29": "Bidet",
    "32": "Cupboard",
    "33": "Vanity cupboard",
    "35": "Jacuzzi bath with shower",
    "36": "Washbasin with mirror",
    "37": "Toilet",
    "46": "Shower unit",
    "50": "Shower room",
    "52": "Bath with shower",
    "53": "WC",
    "55": "Baby bed",
    "56": "Option: baby chair",
    "58": "Radiators",
    "61": "Double bed",
    "63": "Option: baby bed and baby chair",
    "66": "Built-in wardrobes",
    "69": "Wardrobes",
    "70": "Night table",
    "71": "Night tables",
    "72": "Reading lamps",
    "73": "Desk",
    "74": "TV",
    "78": "Chest of drawers",
    "79": "Bathroom/WC",
    "81": "Bathroom",
    "82": "Bathrooms",
    "87": "Bedrooms",
    "89": "Balcony",
    "91": "Small terrace",
    "92": "Conservatory with dining table and chairs",
    "93": "Terraces",
    "94": "Kitchen in the living / dining room",
    "96": "Small Balcony",
    "97": "Hall",
    "98": "Corridor",
    "99": "Lounge",
    "100": "Terrace",
    "101": "Kitchen",
    "102": "Modern Kitchen",
    "106": "Bookcases",
    "110": "Cooking hob with an oven",
    "114": "Cooking hob",
    "115": "Oven",
    "118": "Modern style",
    "119": "Cooker",
    "123": "Electric kettle",
    "124": "Microwave",
    "125": "Toaster",
    "127": "Traditional",
    "128": "Plates",
    "129": "Pans",
    "130": "Fridge / freezer",
    "131": "Fridge",
    "133": "Mini ironing board",
    "134": "Washing machine with drier",
    "135": "Fully equipped kitchen",
    "137": "Clothes washer drier",
    "140": "Coffee maker",
    "142": "Dish rack",
    "143": "Vacuum cleaner",
    "144": "Tea pot",
    "146": "Gas/electric hob",
    "147": "Electric oven",
    "150": "Breakfast bar and stools",
    "151": "Kitchen table and chairs",
    "152": "Freezer",
    "157": "Kitchenette",
    "161": "Armchairs",
    "163": "Coffee table",
    "166": "TV (local channels only)",
    "167": "Satellite TV",
    "174": "Internet connection",
    "180": "Air conditioning",
    "181": "Air conditioning/heating",
    "182": "Sofa",
    "186": "Portable air conditioning unit",
    "187": "Heating",
    "188": "Lamp",
    "189": "Table and chairs",
    "192": "Leather sofa",
    "193": "Armchair and footstool",
    "197": "Shelves",
    "198": "Radio",
    "199": "Computer with free ASDL internet access",
    "200": "Double sofa bed",
    "201": "Wardrobe",
    "203": "Double sofa",
    "204": "Comfortable lounge on site",
    "205": "Help Desk",
    "208": "High Chairs",
    "209": "Extra Bed",
    "210": "Mattress",
    "215": "Airport Pick-up Service",
    "225": "Maid Service",
    "227": "Swimming pool",
    "231": "Weekly cleaning for free",
    "232": "Dry Cleaning & Laundry",
    "233": "Dry Cleaning",
    "234": "Laundry",
    "235": "Breakfast",
    "237": "Sofabed",
    "239": "Shower",
    "245": "Washbasin",
    "248": "Storage space",
    "249": "Living room",
    "250": "Dining table",
    "252": "Bath",
    "253": "Jacuzzi",
    "257": "Bedroom",
    "258": "Stove",
    "261": "Fan",
    "277": "Antique furniture",
    "281": "Wheelchair access possible",
    "294": "A Gym is in the building for guests to use",
    "295": "On street parking",
    "296": "Underground parking",
    "298": "Building attendant",
    "302": "Guarded parking",
    "308": "Telephone (incoming calls only)",
    "309": "Telephone (incoming and outgoing calls)",
    "311": "Dressing table",
    "312": "Fax Machine",
    "314": "Internet (computer supplied)",
    "315": "Bathtub",
    "320": "Separate entry",
    "321": "Separate bath",
    "322": "A door to the terrace",
    "323": "Single bed",
    "324": "King size bed",
    "325": "DVD player",
    "326": "CD selection",
    "327": "DVD selection",
    "328": "Floor heating",
    "330": "City maps",
    "331": "Full-stocked fridge",
    "332": "Brochures",
    "334": "FREE food and drinks",
    "336": "FREE fruits",
    "337": "FREE flower bouquets",
    "338": "FREE firewood for the fireplace",
    "339": "FREE internet access",
    "341": "Fine egyptian cotton sheets",
    "342": "Selection of food and drinks",
    "344": "Bathrobe",
    "345": "LCD panel",
    "346": "Garden",
    "347": "Large selection of luxury food, drinks, wines, coffees and teas",
    "348": "Fully stocked fridge with all thinkable fresh food, drink items",
    "349": "Wood burning fireplace",
    "351": "Large terry cloth bathtowels",
    "352": "\"Molton Brown\" amenities",
    "353": "Orchid plants",
    "354": "FREE international phoneline",
    "355": "Upon weekly stays: maidservice including personal laundry / ironing",
    "359": "Piano",
    "360": "Tumble dryer",
    "361": "Extractor Hood",
    "362": "Shared Kitchen, Living room and Garden with another quests",
    "363": "Armchair",
    "364": "Fireplace",
    "365": "Sauna",
    "368": "Free Wireless Internet",
    "371": "Home Theatre",
    "372": "Livingroom / Bedroom",
    "373": "Common Kitchen",
    "374": "Cell Phone Rentals",
    "375": "Fax and Photocopy Services",
    "376": "Coffee Pot",
    "379": "Digital Cable TV",
    "380": "Complimentary Tea & Coffee",
    "382": "Sidechairs",
    "384": "Bunk beds (sgl on top, dbl on bottom)",
    "385": "Cots, High Chairs, Mattress (on request)",
    "388": "Loft",
    "389": "Flat Screen Plasma TV",
    "390": "Espresso-Machine",
    "391": "Hot Tub",
    "395": "Towels",
    "396": "Alcove bedroom",
    "397": "End table",
    "404": "Health Club",
    "408": "BBQ grill",
    "409": "En suite bathroom",
    "412": "Walk in closet",
    "413": "Ice Maker",
    "414": "Dual wash basin",
    "415": "Spa pool",
    "417": "Free long distance phone calls",
    "418": "Video game system",
    "419": "Video game system w/games",
    "420": "Free use of 2-way radios",
    "421": "Game room",
    "422": "Initial toiletries",
    "426": "Telephone (incoming and local outgoing calls)",
    "428": "Armchair that can turn into a single bed",
    "429": "Computer rental",
    "432": "Sleeper chair",
    "433": "Free high speed wireless internet",
    "434": "Toilet/bidet",
    "435": "Gas stove",
    "436": "Blender",
    "437": "Hot plates",
    "438": "High speed Internet access",
    "439": "Dining room",
    "440": "Pair of twin beds",
    "444": "Bunk Bed",
    "445": "Big Screen TV",
    "446": "Complimentary Soap/Shampoo/Conditioner",
    "447": "Heated towel bar",
    "448": "Free weekly cleaning",
    "449": "River",
    "450": "Street",
    "451": "Courtyard",
    "452": "Square",
    "453": "Annex Room",
    "454": "Marble floor",
    "455": "2 single beds in the lounge",
    "456": "Chairs",
    "457": "Conservatory",
    "458": "Hydro-Massage Shower",
    "459": "Parquet floor",
    "460": "Sectional sofa",
    "461": "Business centre",
    "462": "State of the art appliances",
    "463": "Granite countertops",
    "464": "Custom cabinetry",
    "465": "Tennis Court",
    "466": "Day Care",
    "467": "Residence gym",
    "468": "LCD flat screen TV",
    "472": "Personal Shopping Service",
    "473": "Den",
    "476": "Skyline",
    "478": "Downtown",
    "479": "Golf Course",
    "480": "Widescreen TV",
    "481": "Wooden floor",
    "482": "Electric shaver",
    "483": "Wooden windows",
    "484": "Guide books",
    "485": "Queen size bed",
    "490": "Fan(s) on request",
    "491": "Iron/Ironing board on request",
    "497": "Luggage Storage Facilities",
    "499": "Hanger",
    "500": "Bookshelf",
    "501": "Day bed",
    "503": "Mirror",
    "504": "Private parking",
    "505": "Cloakroom",
    "506": "Cupboards",
    "507": "Table",
    "508": "Chair",
    "509": "Reading lamp",
    "510": "Lake",
    "511": "Sea",
    "512": "Ocean",
    "513": "Canal",
    "514": "Mezzanine",
    "515": "Wallbed",
    "516": "En suite shower",
    "517": "Bedroom/Living room with kitchen corner",
    "589": "Bed Linen",
    "590": "Iron",
    "591": "Ironing Board",
    "592": "Telephone",
    "593": "Computer",
    "594": "Canal view",
    "595": "Pets are welcome",
    "596": "Free cot in the apartment",
    "597": "Free cot on request",
    "598": "Concierge",
    "599": "Washer dryer",
    "600": "Dryer",
    "601": "Safe",
    "602": "Ski Storage",
    "603": "Mountain View",
    "604": "Seaview",
    "605": "Fitness Room",
    "606": "Spa",
    "607": "Steam room",
    "608": "Room Service",
    "609": "Slope View",
    "611": "Hot Tub (Private)",
    "612": "Hot Tub (Common)",
    "613": "Laundry (Private)",
    "614": "Laundry (Common)",
    "615": "Minibar",
    "616": "Doorman",
    "617": "Breakfast Room",
    "618": "Meeting Room",
    "619": "Restaurant",
    "620": "Bar",
    "621": "Beauty Salon",
    "622": "Children Area",
    "623": "Ski In and Out",
    "624": "Pull-Out Bed",
    "625": "Garden (Private)",
    "626": "Garden (Common)",
    "627": "Reception",
    "628": "Laundry Service",
    "629": "Adjoining Rooms",
    "630": "Outlet Adapters",
    "631": "Airline Desk",
    "632": "Meal Plan - American",
    "633": "ATM/Cash Machine",
    "634": "Audio Visual Equipment",
    "635": "Babysitting/Child Services",
    "636": "Barber Shop",
    "637": "On The Bay",
    "638": "Bay View",
    "639": "Meal Plan - Bed and Breakfast",
    "640": "Baby Listening Device",
    "641": "Beach View",
    "642": "Beach",
    "643": "Barber/Beauty Shop",
    "644": "Porters",
    "645": "Bicycle Rentals",
    "646": "Blackboard",
    "647": "Billiards / Pool Tables",
    "648": "Boating",
    "649": "Boutiques",
    "650": "Bowling",
    "651": "Meal Plan - Bermuda",
    "652": "Braille Elevator",
    "653": "Breakfast Buffet",
    "654": "Bathroom Telephone",
    "655": "Canopy / Poster Bed",
    "656": "Car Rental Desk",
    "657": "Casino",
    "658": "Castle Room",
    "659": "Meal Plan - Caribbean",
    "660": "CD Player",
    "661": "Ceiling Fan",
    "662": "City View",
    "663": "Conference Facilities",
    "664": "Conference Suite",
    "665": "Continental Breakfast",
    "666": "Coffee Shop",
    "667": "Coffee Maker in Room",
    "668": "Computer in Room",
    "669": "Concierge Desk",
    "670": "Connecting Rooms",
    "671": "Meal Plan - Continental",
    "672": "Copy Service",
    "673": "Cordless Phone",
    "674": "Cribs Available",
    "675": "Courtesy Car",
    "676": "City Center",
    "677": "Currency Exchange",
    "678": "Data port Available",
    "679": "24 Hour Front Desk",
    "680": "Dining Guide",
    "681": "Dinner",
    "682": "Handicapped Rooms/Facilities",
    "683": "Disco",
    "684": "Doctor on Call",
    "685": "Drugstore",
    "686": "Driving Range",
    "687": "Desk with lamp",
    "688": "Electronic Door Locks",
    "689": "Elevator",
    "690": "Email Service",
    "691": "Live Entertainment",
    "692": "Meal Plan - European",
    "693": "Express Check In",
    "694": "Executive Desk",
    "695": "Express Checkout",
    "696": "Executive Level",
    "697": "Meal Plan - FAP/Full-board",
    "698": "Full English Breakfast",
    "699": "Female Executive Rooms",
    "700": "Fishing",
    "701": "Florist",
    "702": "Free Parking",
    "703": "Free Local Telephone Calls",
    "704": "Free Transportation",
    "705": "Garden View",
    "706": "Gift Shop",
    "707": "Game Rental",
    "708": "Golf",
    "709": "Golf Course View",
    "710": "Horseback Riding",
    "711": "Jogging Track",
    "712": "Kennels",
    "713": "Childrens Activities",
    "714": "Lake View",
    "715": "Guest Laundromat",
    "716": "Lunch",
    "717": "Meal Plan - MAP/Half-board",
    "718": "Massage",
    "719": "Miniature Golf",
    "720": "In Room Movies",
    "721": "Meeting Facilities",
    "722": "Meeting Suite",
    "723": "Multilingual",
    "724": "Nursery for Children",
    "725": "No Smoking Rooms/Facilities",
    "726": "Night Club",
    "727": "Free Newspaper",
    "728": "News Stand",
    "729": "Ocean View",
    "730": "Overhead Projector",
    "731": "Parasailing",
    "732": "Park View",
    "733": "No Pets Allowed",
    "734": "Phone Service",
    "735": "Picnic Area/Tables",
    "736": "Play Ground",
    "737": "Heated Pool",
    "738": "Indoor Pool",
    "739": "Childrens Pool",
    "740": "Outdoor Pool",
    "741": "Poolside Snackbar",
    "742": "Projector",
    "743": "Squash",
    "744": "River View",
    "745": "Ramp Access to Buildings",
    "746": "24 Hour Room Service",
    "747": "Safe Deposit",
    "748": "Sailing",
    "749": "Scuba Diving",
    "750": "Secretarial Service",
    "751": "24 Hour Security",
    "752": "Shopping Mall",
    "753": "Free Airport Shuttle",
    "754": "Skeet Shooting",
    "755": "Skiing",
    "756": "Cross Country Skiing",
    "757": "Snorkeling",
    "758": "Snowboarding",
    "759": "Fitness Center or Spa",
    "760": "Steam Bath",
    "761": "Telex",
    "762": "Indoor Tennis",
    "763": "Tennis",
    "764": "Outdoor Tennis",
    "765": "Tour Desk",
    "766": "Translation Service",
    "767": "Laundry Services",
    "768": "Vending Machines",
    "769": "VIP Rooms/Services",
    "770": "Volleyball",
    "771": "Wake-up Service",
    "772": "Wedding Services",
    "773": "Wind Surfing",
    "774": "Water Skiing",
    "775": "Grab Bars in Bathroom",
    "776": "Heated Guest Rooms",
    "777": "Modem in Room",
    "778": "Murphy Bed",
    "779": "Rollaway Beds",
    "780": "Bathrobes",
    "781": "Smoke Detectors",
    "782": "Solarium",
    "783": "Sprinklers In Rooms",
    "784": "Theater Desk",
    "785": "Temperature Control",
    "786": "Trouser Press",
    "788": "Ipod Dock",
    "789": "Heating",
    "790": "Hi-Fi",
    "791": "Duty Free Shop",
    "792": "Wireless Internet",
    "793": "Parking",
    "794": "Outdoor Parking",
    "795": "Valet Parking",
    "796": "Prayer Mats",
    "797": "Racquetball Courts",
    "798": "Refrigerator",
    "799": "Smoking",
    "800": "Chef Provided",
    "801": "Marina View",
    "802": "Smoking allowed",
    "803": "Free parking on the street",
    "804": "Paid parking on the street",
    "805": "Free parking with garage",
    "806": "Paid parking with garage",
    "807": "Free cable internet",
    "808": "Paid cable internet",
    "809": "Paid wireless internet",
    "810": "Paid cot on request",
    "811": "Petanque",
    "812": "Ask for smoking",
    "813": "Ask for pets",
    "814": "Ask for accessibility",
    "815": "Communal pool",
    "816": "Private pool",
    "817": "Ping-pong table",
    "818": "Breakfast booking possible",
    "819": "House cleaning optional",
    "820": "Sports - swimming",
    "821": "Local hospital",
    "822": "Local groceries",
    "823": "Waterfront",
    "824": "Near ocean",
    "825": "Shared Kitchen",
    "826": "Shared Swimming Pool",
    "827": "Garage",
    "828": "Family/kids friendly",
    "829": "Laptop workspace",
    "830": "Juicer",
    "831": "Security camera at entrance",
    "832": "MP3",
    "833": "Baby cot",
    "834": "Gym",
    "835": "Paddle",
    "836": "Taxi access",
    "837": "Rooftop access",
    "838": "Baby high chair",
    "839": "Baby cot paid",
    "840": "Baby chair on request",
    "841": "High chair on request",
    "842": "Pets paid",
    "843": "Pets accepted under request",
    "844": "Stroller",
    "845": "Baby cutlery",
    "846": "Internet connection on request",
    "847": "Cable TV on request",
    "848": "Dry cleaning on request",
    "849": "Free international calls",
    "850": "Chimney",
    "851": "TV 3D",
    "852": "Smart TV",
    "853": "Free car",
    "854": "Free bike",
    "855": "Credit card payment accepted",
    "856": "No parties",
    "857": "No children under 4",
    "858": "No children under 12",
    "859": "Anyone under 25 years",
    "860": "Anyone under 30 years",
    "861": "Anyone under 35 years",
    "862": "Anyone under 18 years",
    "863": "No reservation more than 30 days",
    "864": "Groups under 18 years",
    "865": "Groups under 25 years",
    "866": "Groups under 30 years",
    "867": "Groups under 35 years",
    "868": "Only families",
    "869": "Anyone under 40 years",
    "870": "No children under 6",
    "871": "Groups under 50 years",
    "872": "Same sex groups under 30 years",
    "873": "Groups under 45 years",
    "874": "Same sex groups under 35 years",
    "875": "Arrivals on Sunday",
    "876": "Families or couples only",
    "877": "Baby high chair paid",
    "878": "Baby chair paid",
    "879": "Wifi USB Adapter",
    "880": "Bottled water",
    "881": "Centrally controlled ventilation",
    "882": "Electrical adapters available",
    "883": "Hypoallergenic rooms",
    "884": "Internet browser TV",
    "885": "Power converters",
    "886": "Sewing kit",
    "887": "Printer",
    "888": "Slippers",
    "889": "Sound system",
    "890": "Sound proofed windows",
    "891": "Weighting scale",
    "892": "Run of the house",
    "893": "Window",
    "894": "Veranda",
    "895": "Patio",
    "896": "AC public areas",
    "897": "Aqua sports center",
    "898": "Courier service",
    "899": "Creche",
    "900": "Housekeeping service",
    "901": "Entertainment recreation",
    "902": "Diving",
    "903": "Hair salon",
    "904": "Hotel shops",
    "905": "Island hopping",
    "906": "Jet skiing",
    "907": "Kids eat for free",
    "908": "Late check-out available",
    "909": "Limo town car service available",
    "910": "Security guard",
    "911": "Shoe shine",
    "912": "Shoe polishing machine",
    "913": "Shuttle service",
    "914": "Suitable for children",
    "915": "Ticket service",
    "916": "Turndown service",
    "917": "Umbrella",
    "918": "Welcome amenities",
    "919": "Country or rural view",
    "920": "Inland view",
    "921": "Panoramic view",
    "922": "Pool view",
    "923": "Village view",
    "924": "Valley view",
    "925": "Town view",
    "926": "Rare view",
    "927": "Loch view",
    "928": "Heated outdoor pool",
    "929": "Infants not allowed",
    "930": "Family friendly",
    "931": "Car necessary",
    "932": "Car recommended",
    "933": "Car not necessary",
    "934": "Romantic",
    "935": "Luxury",
    "936": "Budget",
    "937": "Water View",
    "938": "Beach chair",
    "939": "French bed",
    "940": "Toilet paper",
    "941": "Soap",
    "942": "Children not allowed",
    "943": "Carbon Monoxide Detector",
    "944": "Heated private pool",
    "945": "Table Football",
    "946": "Dartboard",
    "947": "Air Hockey Table",
    "948": "Basketball Hoop",
    "949": "Pool - Safety Fence",
    "950": "Patio Heater",
    "951": "Sun Loungers",
    "952": "External Lighting",
    "953": "Suitable for Elderly",
    "954": "Peaceful",
    "955": "Fire Extinguisher",
    "956": "Walk-in Shower",
    "957": "Tribunk bed",
    "958": "Minimarket on site",
    "959": "Adult only",
    "960": "Towels changed upon request",
    "961": "Room upgrade available upon availability",
    "962": "Guaranteed room upgrade",
    "963": "Free room upgrade available",
    "964": "Resort credit included",
    "965": "Welcome gift upon arrival",
    "966": "Eco friendly cleaning products",
    "967": "Gray water recycling",
    "968": "Renewable energy - geothermal",
    "969": "Renewable energy - solar",
    "970": "Renewable energy - wind",
    "971": "Essentials (towels, pillows, bed linen, soap, toilet paper)",
    "972": "Hangers",
    "973": "Hot water",
    "974": "Washer",
    "976": "Allergy free",
    "977": "Beach towels",
    "978": "Cleaning products",
    "979": "Earplugs",
    "980": "Lockers",
    "981": "Mosquito net",
    "984": "Private curtain",
    "985": "Room climate control",
    "986": "Restaurant guide",
    "987": "Self controlled heating / cooling system",
    "988": "Separate closet",
    "989": "Sun umbrellas",
    "990": "Trash cans",
    "991": "Electric vehicle charging station",
    "992": "Ironing service",
    "993": "Pet basket",
    "994": "Pet bowls",
    "995": "No single use plastics",
    "996": "No single use toiletries",
    "997": "Eligibility for hotel loyalty points",
    "998": "Beachfront",
    "999": "Garden or backyard",
    "1000": "Single level home",
    "1002": "Designated smoking area",
    "1003": "Detached",
    "1004": "Engawa sitting area",
    "1005": "Firepit",
    "1006": "Furnished balcony",
    "1007": "Furnished lanai",
    "1008": "Furnished patio",
    "1009": "Japanese garden",
    "1010": "Living plant wall",
    "1011": "Vegetable garden",
    "1012": "Gulf view",
    "1013": "Harbor view",
    "1014": "Hill view",
    "1015": "Lagoon view",
    "1016": "Lanai",
    "1017": "Landmark view",
    "1018": "Marina",
    "1019": "Multiple views",
    "1020": "No view",
    "1021": "Open air bath",
    "1022": "Outdoor dining area",
    "1023": "Outdoor fireplace",
    "1024": "Outdoor furniture",
    "1025": "Boat",
    "1026": "Outdoor entertainment area",
    "1027": "Water sports gear",
    "1028": "Partial lake view",
    "1029": "Partial view",
    "1030": "Porch",
    "1031": "Private flat in block of flats",
    "1032": "Quiet street view",
    "1033": "Resort view",
    "1034": "Semi detached",
    "1035": "Sun terrace",
    "1036": "Desert view",
    "1037": "Partial ocean view",
    "1038": "Partial sea view",
    "1039": "Vineyard view",
    "1040": "1 game drive per night",
    "1041": "2 game drives per night",
    "1042": "Bingo",
    "1043": "Board games/puzzles",
    "1044": "Books",
    "1045": "Casino credit",
    "1046": "Casino nearby",
    "1047": "Concerts or live performances",
    "1048": "Cooking class",
    "1049": "Disney park tickets",
    "1050": "Entertainment staff",
    "1051": "Evening entertainment",
    "1052": "Fitness classes",
    "1053": "Fitness facilities",
    "1054": "Fitness facilities nearby",
    "1055": "Fitness spa locker rooms",
    "1056": "Foot bath",
    "1057": "Free water park passes",
    "1058": "Happy hour",
    "1059": "Hot springs nearby",
    "1060": "Hot springs onsite",
    "1061": "Indoor publicbath no mineral springs",
    "1062": "Infinity pool",
    "1063": "Jetted tub",
    "1064": "Karaoke",
    "1065": "Leisure gambling",
    "1066": "Library",
    "1067": "Live sports events broadcast",
    "1068": "Massage chair",
    "1069": "Match play",
    "1070": "Mineral hot springs indoor",
    "1071": "Mineral hot springs outdoor",
    "1072": "Movie nights",
    "1073": "Outdoor public bath - no mineral springs",
    "1074": "Personal trainer available",
    "1075": "Plunge pool",
    "1076": "Pool bar",
    "1077": "Pool cover",
    "1078": "Pool towels",
    "1079": "Pool with view",
    "1080": "Pool above ground",
    "1081": "Pool cabanas",
    "1083": "Pool in ground",
    "1084": "Pool sun loungers",
    "1085": "Pool umbrellas",
    "1086": "Pool waterfall",
    "1087": "Private beach area",
    "1088": "Pub crawls",
    "1089": "Public bath",
    "1090": "Rooftop pool",
    "1091": "Art supplies",
    "1092": "Musical instruments",
    "1093": "Private mineral hot springs - indoor",
    "1094": "Private mineral hot springs - outdoor",
    "1095": "Salt water pool",
    "1096": "Shallow end pool",
    "1097": "Slot play",
    "1098": "Stand up comedy",
    "1099": "Swim up bar",
    "1100": "Swimming pool toys",
    "1101": "Telescope",
    "1102": "Temporary art galleries",
    "1103": "Themed dinner nights",
    "1104": "Tour or class about local culture",
    "1105": "Trampoline",
    "1106": "Walking tours",
    "1107": "Waterslide",
    "1108": "Whirpool",
    "1109": "Winery",
    "1110": "Winery private tours onsite",
    "1111": "Winery public tours onsite",
    "1112": "Winery release events onsite",
    "1113": "Winery tasting room onsite",
    "1114": "Winery tours nearby",
    "1115": "Winery vineyard onsite",
    "1116": "Yoga classes",
    "1117": "Golf credit",
    "1118": "Shopping",
    "1119": "Ice skating nearby",
    "1120": "Ice skating onsite",
    "1121": "Aerobics",
    "1122": "Archery onsite",
    "1123": "Theme parks",
    "1124": "Badminton equipment",
    "1125": "Near private beach direct access",
    "1126": "Near public beach direct access",
    "1127": "Beach cabanas",
    "1128": "Beach volleyball onsite",
    "1129": "Beach yoga onsite",
    "1130": "Bike tours",
    "1131": "Biking on road nearby",
    "1132": "Birdwatching nearby",
    "1133": "Birdwatching onsite",
    "1134": "Canoe onsite",
    "1135": "Boat onsite",
    "1136": "Inflatable boat onsite",
    "1137": "Kayak onsite",
    "1138": "Pedal boat onsite",
    "1139": "Sailboat onsite",
    "1140": "Boat tours nearby",
    "1141": "Boat tours onsite",
    "1142": "Cave exploring nearby",
    "1143": "Cave exploring onsite",
    "1144": "Cycling",
    "1145": "Ecotours nearby",
    "1146": "Ecotours onsite",
    "1147": "Farming classes",
    "1148": "Fish cleaning table",
    "1149": "Game drive nearby",
    "1150": "Game drive onsite",
    "1151": "Game or wildlife walk nearby",
    "1152": "Game or wildlife walk onsite",
    "1153": "Game viewing nearby",
    "1154": "Game viewing onsite",
    "1155": "Golf caddy",
    "1156": "Golf cart",
    "1157": "Golf clubhouse",
    "1158": "Golf equipment",
    "1159": "Golf course without driving range",
    "1160": "Golf pro shop",
    "1161": "Helicopter or plane tours onsite",
    "1162": "Hiking",
    "1163": "Hiking biking nearby",
    "1164": "Hiking biking onsite",
    "1165": "Hunting nearby",
    "1166": "Hunting onsite",
    "1167": "Kayaking nearby",
    "1168": "Kayaking onsite",
    "1169": "Lazy river",
    "1170": "Motor boat nearby",
    "1171": "Motor boat onsite",
    "1172": "Mountain climbing nearby",
    "1173": "Personal watercraft nearby",
    "1174": "Personal watercraft onsite",
    "1175": "Rafting nearby",
    "1176": "Rafting onsite",
    "1177": "Ropes course team building onsite",
    "1178": "Rowing or canoeing onsite",
    "1179": "Safari nearby",
    "1180": "Safari onsite",
    "1181": "Scuba diving nearby",
    "1182": "Skydiving nearby",
    "1183": "Skydiving onsite",
    "1184": "Snorkeling nearby",
    "1185": "Surfing or boogieboarding nearby",
    "1186": "Surfing or boogieboarding onsite",
    "1187": "Tennis equipment",
    "1188": "Tennis lessons onsite",
    "1189": "Walkway to water",
    "1191": "Water park",
    "1192": "Water skiing nearby",
    "1193": "Water tubing nearby",
    "1194": "Windsurfing nearby",
    "1195": "Ziplining nearby",
    "1196": "Ziplining onsite",
    "1197": "Beach sand type: sand",
    "1198": "Beach sand type: black sand",
    "1199": "Beach sand type: white sand",
    "1201": "Accessible height toilet",
    "1202": "Bathroom step free access",
    "1203": "Bathroom wide doorway",
    "1204": "Bedroom step free access",
    "1205": "Bedroom wide doorway",
    "1206": "Ceiling hoist",
    "1207": "Common space step free access",
    "1208": "Common space wide doorway",
    "1209": "Parking spot for disabled",
    "1210": "Electric profiling bed",
    "1211": "First aid kit",
    "1212": "Handheld shower head",
    "1213": "Home step free access",
    "1214": "Home wide doorway",
    "1215": "Lock on bedroom door",
    "1216": "Mobile hoist",
    "1217": "Path to entrance lit at night",
    "1218": "Pool hoist",
    "1219": "Private entrance",
    "1220": "Rollin shower",
    "1221": "Shower chair",
    "1222": "Tub with shower bench",
    "1223": "Wide clearance to bed",
    "1224": "Wide clearance to shower and toilet",
    "1225": "Wide hallway clearance",
    "1226": "Accessible bathroom",
    "1227": "Accessible parking",
    "1228": "Accessible path of travel",
    "1229": "Adapted bath",
    "1230": "Auditory guidance",
    "1231": "Bathroom emergency pull cord",
    "1232": "Bed rails",
    "1233": "Cabinet locks",
    "1234": "Corner guards",
    "1235": "Electronic key card access",
    "1237": "Entire property on ground floor",
    "1238": "Equipment for deaf",
    "1239": "Laptop safe box",
    "1240": "Low bathroom sink",
    "1241": "Medical emergency contact",
    "1242": "Metal keys access",
    "1243": "Police emergency contact",
    "1244": "Room safety pool gate",
    "1245": "Safe large enough to accommodate a laptop",
    "1246": "Room safety security system",
    "1248": "Upper floor reachable by stairs only",
    "1249": "Visual aids: braille",
    "1250": "Visual aids: tactile signs",
    "1251": "Window guards",
    "1252": "Safety: balcony warning",
    "1253": "Safety: fully fenced property",
    "1254": "Chapel or shrine",
    "1255": "Family rooms",
    "1256": "Bridal suite",
    "1257": "Soundproof rooms",
    "1258": "2 bathrooms",
    "1259": "Ensuite",
    "1260": "Private bathroom",
    "1261": "Shared bathroom",
    "1262": "Full kitchen",
    "1263": "Dressing room",
    "1264": "Interconnecting room(s) available",
    "1265": "Large desk",
    "1266": "Sitting area",
    "1267": "Desk with electrical outlet",
    "1268": "Closets in room",
    "1269": "Chair provided with desk",
    "1270": "Dining room seats",
    "1271": "Multiple closets",
    "1272": "Seating area",
    "1273": "Carpeted floor",
    "1274": "Dining area",
    "1276": "Clothes rack",
    "1277": "Room decor",
    "1278": "Cleaning before checkout",
    "1282": "Housekeeping daily",
    "1283": "Housekeeping once per stay",
    "1284": "Housekeeping weekends only",
    "1285": "Housekeeping weekdays only",
    "1286": "Room service limited",
    "1287": "Room service generic",
    "1288": "2 for 1 buffet",
    "1289": "All meals",
    "1290": "All inclusive",
    "1291": "Beach bar",
    "1292": "Breakfast for 1",
    "1293": "Breakfast for 2",
    "1294": "Breakfast in the room",
    "1295": "Chocolate cookies",
    "1296": "Coffee tea maker",
    "1297": "Complimentary wine reception",
    "1298": "Continental breakfast for 2",
    "1299": "Couples dining",
    "1300": "Drinks and hors doeuvres",
    "1301": "Food beverage credit",
    "1302": "Free breakfast for 1 adult",
    "1303": "Free dinner for 1 adult",
    "1304": "Free welcome drink",
    "1305": "Full board",
    "1306": "Grocery store",
    "1307": "Half board",
    "1308": "Mini refrigerator",
    "1309": "On site coffee house",
    "1310": "Packed lunches",
    "1311": "Refrigerator with ice maker",
    "1312": "In-room dining only",
    "1313": "Snack bar",
    "1314": "Special diet menus on request",
    "1315": "Tea service",
    "1319": "Wine glasses",
    "1320": "Wine champagne",
    "1321": "Baby bath",
    "1322": "Changing table",
    "1323": "Childrens books and toys",
    "1324": "Childrens dinnerware",
    "1325": "Fireplace guards",
    "1326": "Outlet covers",
    "1327": "Room darkening shades",
    "1328": "Stair gates",
    "1329": "Table corner guards",
    "1330": "Baby safety gates",
    "1331": "Board games puzzles",
    "1332": "Book dvd music library for children",
    "1333": "Children television networks",
    "1334": "Childrens games",
    "1335": "Entertainment toys",
    "1336": "Indoor play area",
    "1337": "Infant toddler toys",
    "1338": "Kid meals",
    "1339": "Kids outdoor play equipment",
    "1340": "Child dishware",
    "1341": "Childcare",
    "1342": "Child size slippers",
    "1344": "Extra large double",
    "1345": "Extra long beds 2 meter",
    "1346": "Futon mat",
    "1347": "Large double",
    "1348": "Down comforter",
    "1349": "Hypo bed available",
    "1350": "Accessible height bed",
    "1352": "Cooking basics",
    "1353": "Kitchen supplies",
    "1354": "Kitchen dining area",
    "1355": "Kitchenware",
    "1356": "Microwave shared not in room",
    "1357": "Refrigerator microwave",
    "1358": "Coffee grinder",
    "1359": "Griddle",
    "1360": "Lobster pot",
    "1361": "Mixer",
    "1362": "Spices",
    "1363": "Stovetop",
    "1364": "Waffle maker",
    "1366": "Entertainment video library",
    "1367": "Free movies / video",
    "1368": "Pay per view movies on tv",
    "1369": "List of movie channels available",
    "1370": "cnn available",
    "1371": "Bluray player",
    "1372": "Pay per view channels",
    "1373": "First run movies",
    "1374": "Premium tv channels",
    "1375": "Streaming service such as netflix",
    "1376": "Video on demand",
    "1377": "Includes one free in room movie",
    "1378": "Laptop",
    "1379": "Telephone tdd textphone",
    "1380": "Multi line phone",
    "1381": "Telephone for hearing impaired",
    "1382": "Two-line phone",
    "1383": "Satellite radio",
    "1384": "Mobile / cellular phones available",
    "1385": "Ipad",
    "1386": "Game console xbox 360",
    "1387": "Game console playstaytion 2",
    "1388": "Game console playstation 3",
    "1389": "Game console nintendo wii",
    "1390": "Game console xbox one",
    "1391": "Game console wii u",
    "1392": "Game console playstation 4",
    "1393": "Smartphone available",
    "1394": "Electric vehicle charger",
    "1395": "Tour assistance",
    "1396": "Frette italian sheets",
    "1397": "Premium mattress",
    "1398": "Business lounge access",
    "1399": "Free calls available",
    "1400": "Champagne service",
    "1401": "Luxury tents",
    "1402": "Free fitness center access",
    "1403": "Free business center access",
    "1404": "Vip line access to nightclub(s)",
    "1406": "Bath linens",
    "1407": "Bath tub with spray jets",
    "1408": "Bathtub only",
    "1409": "Grecian tub",
    "1410": "Shower only",
    "1411": "Bathtub and whirlpool separate",
    "1412": "Oversized bathtub",
    "1413": "Separate tub and shower",
    "1414": "Separate toilet area",
    "1415": "Spa bath",
    "1417": "Guest toilet",
    "1418": "Additional toilet",
    "1419": "Additional bathroom",
    "1420": "Toothbrush",
    "1421": "Shower cap",
    "1422": "Shared bathroom with sink",
    "1424": "Outdoor partially open bathroom",
    "1425": "Child size bathrobes",
    "1426": "Electronic bidet",
    "1427": "Designer toiletries",
    "1428": "Geta sandals",
    "1429": "Private spa tub",
    "1430": "Deep soaking bathtub",
    "1431": "Spring water room bathtub",
    "1432": "Baby bath with rainfall showerhead",
    "1433": "Paper towels",
    "1434": "Hair dryer on request",
    "1435": "Laundry detergent",
    "1436": "Bed linens",
    "1437": "Extra pillows and blankets",
    "1438": "Electric blankets",
    "1439": "Pajamas",
    "1440": "Yukata",
    "1441": "Socket near the bed",
    "1442": "Feather pillows",
    "1443": "Non feather pillows",
    "1444": "Hypoallergenic pillows",
    "1445": "Pillow menu",
    "1446": "Ski lift privileges optional",
    "1447": "Snowboarding onsite",
    "1448": "Sledding nearby",
    "1449": "Sledding onsite",
    "1450": "Snow tubing nearby",
    "1451": "Snow tubing onsite",
    "1452": "Snowmobiling nearby",
    "1453": "Snowmobiling onsite",
    "1454": "Snowshoeing nearby",
    "1455": "Snowshoeing onsite",
    "1456": "Ski area nearby",
    "1457": "Ski lifts nearby",
    "1458": "Ski runs nearby",
    "1459": "Ski lessons nearby",
    "1460": "Ski lessons onsite",
    "1461": "Ski lift privileges",
    "1462": "Ski passes",
    "1463": "Ski rentals nearby",
    "1464": "Ski rentals onsite",
    "1465": "Snow sports gear",
    "1466": "Downhill nearby",
    "1467": "Downhill onsite",
    "1468": "Ski school",
    "1469": "Ski equipment hire on site",
    "1470": "Ski pass vendor",
    "1471": "Ski shuttle",
    "1472": "Ski to door access",
    "1473": "Free ski lift ticket rental",
    "1475": "Ski shuttle nearby",
    "1476": "Spa communal pool",
    "1477": "Spa hot tub",
    "1478": "Spa private pool",
    "1479": "Aromatherapy",
    "1480": "Ayurvedic",
    "1481": "Body scrubs",
    "1483": "Body wraps",
    "1485": "Hydrotherapy",
    "1486": "Couples spa rooms",
    "1487": "Outdoor treatment area",
    "1488": "Thalassotherapy",
    "1489": "Turkish bath",
    "1490": "Detoxification wrap",
    "1491": "Reflexology",
    "1492": "Hot springs",
    "1493": "Sauna in spa",
    "1494": "Mud bath in spa",
    "1495": "Spa tub in spa",
    "1496": "Steam room in spa",
    "1497": "Manicure pedicure",
    "1498": "Pilates onsite",
    "1499": "Massage - advanced booking required",
    "1500": "Beach massage",
    "1501": "Deep tissue massage",
    "1502": "Hot stone massage",
    "1503": "Prenatal massage",
    "1504": "Sports massage",
    "1505": "Swedish massage",
    "1506": "Thai massage",
    "1507": "Spa facilities",
    "1508": "Spa lounge relaxation area",
    "1509": "Spa wellness packages",
    "1510": "Back massage",
    "1511": "Neck massage",
    "1512": "Foot massage",
    "1513": "Couples massage",
    "1514": "Head massage",
    "1515": "Hand massage",
    "1516": "Full body massage",
    "1517": "Hair dresser beautician",
    "1518": "Facial treatments",
    "1519": "Waxing services",
    "1520": "Make up services",
    "1521": "Hair treatments",
    "1522": "Manicure",
    "1523": "Pedicure",
    "1524": "Hair cut",
    "1525": "Hair colouring",
    "1526": "Hair styling",
    "1527": "Body treatments",
    "1528": "Body scrub",
    "1529": "Light therapy",
    "1530": "Spa credit",
    "1538": "Accommodations other services car available",
    "1539": "Electric car charging station",
    "1540": "Scooter or moped rental nearby",
    "1541": "Scooter or moped rental onsite",
    "1542": "Airport shuttle service surcharge",
    "1543": "Public transport tickets",
    "1544": "Private check in check out",
    "1545": "Free return airport transfer",
    "1546": "Parking limited spaces available",
    "1547": "Segway tour nearby",
    "1548": "Segway tour onsite",
    "1549": "Airport shuttle drop off free",
    "1550": "Airport shuttle drop off at surcharge",
    "1551": "Airport shuttle pickup free",
    "1552": "Airport shuttle pickup at surcharge",
    "1553": "Airport shuttle roundtrip free",
    "1554": "Airport shuttle time roundtrip at surcharge",
    "1555": "Airport shuttle time generic",
    "1556": "Airport shuttle time available 24hours",
    "1557": "Airport shuttle time no shuttle",
    "1558": "Airport shuttle - limited hours",
    "1559": "Airport shuttle - time available on request",
    "1560": "Airport shuttle fee adult available during scheduled times",
    "1561": "Airport shuttle fee adult contact property prior to arrival",
    "1562": "Airport shuttle fee adult fee amt",
    "1563": "Area shuttle free",
    "1564": "Area shuttle distance surcharge",
    "1565": "Area shuttle distance generic",
    "1566": "Beach shuttle free",
    "1567": "Beach shuttle surcharge",
    "1568": "Shopping center shuttle free",
    "1569": "Shopping center shuttle surcharge",
    "1570": "Casino shuttle free",
    "1571": "Casino shuttle surcharge",
    "1572": "Theme park shuttle free",
    "1573": "Theme park shuttle surcharge",
    "1574": "Cruise terminal shuttle free",
    "1575": "Cruise terminal shuttle surcharge",
    "1576": "Ferry terminal shuttle surcharge",
    "1577": "Ferry terminal shuttle contact property prior to arrival",
    "1578": "Ferry terminal shuttle free",
    "1579": "Train station pickup service surcharge",
    "1580": "Train station pickup service contact property prior to arrival",
    "1581": "Train station pickup service free",
    "1582": "Train shuttle time surcharge",
    "1583": "Train shuttle time available 24hours",
    "1584": "Train shuttle time available during scheduled times",
    "1585": "Train shuttle time available limited hours",
    "1586": "Train shuttle time available on request",
    "1587": "Must contact property for pickup drop off free",
    "1588": "Must contact property for pickup drop off surcharge",
    "1589": "Must contact property for pickup onarrival",
    "1590": "Must contact property for pickup 24 hours prior to arrival",
    "1592": "Must contact property for pickup 48 hours prior to arrival",
    "1593": "Must contact property for pickup 72 hours prior to arrival",
    "1594": "Dining snack bar or deli",
    "1595": "Childrens menu",
    "1596": "Cuisine afghan",
    "1597": "Cuisine african",
    "1598": "Cuisine american",
    "1599": "Cuisine argentinean",
    "1600": "Cuisine asian",
    "1601": "Cuisine barbecue",
    "1602": "Cuisine basque",
    "1603": "Cuisine belgian",
    "1604": "Cuisine brazilian",
    "1605": "Cuisine british",
    "1606": "Cuisine burmese",
    "1607": "Cuisine cajun or creole",
    "1608": "Cuisine californian",
    "1609": "Cuisine cambodian",
    "1610": "Cuisine caribbean",
    "1611": "Cuisine chinese",
    "1612": "Cuisine cuban",
    "1613": "Cuisine dim sum",
    "1614": "Cuisine eastern european",
    "1615": "Cuisine eritrean",
    "1616": "Cuisine ethiopian",
    "1617": "Cuisine filipino",
    "1618": "Cuisine fish and chips",
    "1619": "Cuisine fondue",
    "1620": "Cuisine french",
    "1621": "Cuisine fusion",
    "1622": "Cuisine german",
    "1623": "Cuisine greek",
    "1624": "Cuisine halal",
    "1625": "Cuisine hawaiian",
    "1626": "Cuisine himalayan",
    "1627": "Cuisine hungarian",
    "1628": "Cuisine indfivesian",
    "1629": "Cuisine indian",
    "1630": "Cuisine international",
    "1631": "Cuisine irish",
    "1632": "Cuisine italian",
    "1633": "Cuisine japanese",
    "1634": "Cuisine korean",
    "1635": "Cuisine kosher",
    "1636": "Cuisine laotian",
    "1637": "Cuisine live or raw",
    "1638": "Cuisine local",
    "1639": "Cuisine local and international",
    "1640": "Cuisine malaysian",
    "1641": "Cuisine mediterranean",
    "1642": "Cuisine mexican",
    "1643": "Cuisine middle eastern",
    "1644": "Cuisine modern european",
    "1645": "Cuisine mongolian",
    "1646": "Cuisine moroccan",
    "1647": "Cuisine pakistani",
    "1648": "Cuisine pan asian",
    "1649": "Cuisine persian iranian",
    "1650": "Cuisine peruvian",
    "1651": "Cuisine pizza",
    "1652": "Cuisine polish",
    "1653": "Cuisine portuguese",
    "1654": "Cuisine regional",
    "1655": "Cuisine russian",
    "1656": "Cuisine scandinavian",
    "1657": "Cuisine seafood",
    "1658": "Cuisine singaporean",
    "1659": "Cuisine soul food",
    "1660": "Cuisine southern",
    "1661": "Cuisine spanish",
    "1662": "Cuisine sushi",
    "1663": "Cuisine taiwanese",
    "1664": "Cuisine tex mex",
    "1665": "Cuisine thai",
    "1666": "Cuisine turkish",
    "1667": "Cuisine ukrainian",
    "1668": "Cuisine vegan",
    "1669": "Cuisine vegetarian",
    "1670": "Cuisine vietnamese",
    "1671": "Has bar",
    "1672": "Location al fresco",
    "1673": "Location beachfront",
    "1674": "Location garden view",
    "1675": "Location golf view",
    "1676": "Location ocean view",
    "1677": "Location pool view",
    "1678": "Location poolside",
    "1680": "Brunch",
    "1683": "Light fare",
    "1685": "Reservations required",
    "1686": "Bistro",
    "1687": "Brasserie",
    "1688": "Buffet",
    "1689": "Cafe",
    "1691": "Delicatessen",
    "1692": "Diner",
    "1693": "Family restaurant",
    "1694": "Fine dining",
    "1695": "Pub",
    "1697": "Seafood",
    "1698": "Steakhouse",
    "1699": "Sushi bar",
    "1700": "Tapas",
    "1701": "Theme",
    "1702": "Adventure sport property theme",
    "1703": "Beach property theme",
    "1704": "Business property theme",
    "1705": "Casino property theme",
    "1706": "Family property theme",
    "1707": "Golf property theme",
    "1708": "Hot springs property theme",
    "1709": "Ski property theme",
    "1710": "Spa property theme",
    "1711": "Romantic property theme",
    "1712": "Winery property theme",
    "1713": "City property theme",
    "1714": "Natural property theme",
    "1715": "Shopping property theme",
    "1716": "Property design baroque",
    "1717": "Property design beaux arts",
    "1718": "Property design belle epoque",
    "1719": "Property design colonial",
    "1720": "Property design deco",
    "1721": "Property design edwardian",
    "1722": "Property design georgian",
    "1723": "Property design mediterranean",
    "1724": "Property design traditional",
    "1725": "Property design tudor",
    "1726": "Property design tuscan",
    "1727": "Property design victorian",
    "1728": "Parking reservation required",
    "1729": "Internet coverage public areas",
    "1730": "Internet coverage all rooms",
    "1731": "Internet coverage some rooms",
    "1732": "Internet coverage business centre",
    "1733": "Parties allowed",
    "1734": "Courtyard view",
    "1735": "Smoking not allowed",
    "1736": "Suitable for infants",
    "1741": "Guest ID required on check-in",
    "1742": "Guests with tattoos not allowed",
    "1743": "Pedestrian zone only",
    "1744": "Access by unpaved road",
    "1745": "Residential area",
    "1746": "Busy area",
    "1747": "Guest Identification Required",
    "1748": "Tattoos Not Allowed",
    "1749": "Pedestrian Zone",
    "1750": "Unpaved Road Access",
    "1751": "Residential Area",
    "1752": "Busy Area",
    "1753": "Enhanced cleaning practices",
    "1754": "Cleaning by professional cleaning companies",
    "1755": "Disinfectants used for cleaning",
    "1756": "Cleaning chemicals that are effective against Coronavirus used",
    "1757": "Social distancing following guidelines from local authorities",
    "1758": "Process in place to check guests' health",
    "1759": "Faces masks available",
    "1760": "Hand sanitizer available",
    "1761": "Screens or physical barriers placed between staff and guests in appropriate areas",
    "1762": "Contactless check-in and checkout is available.",
    "1763": "Contactless check-in available",
    "1764": "Contactless check-out available",
    "1765": "Staff follow all safety protocols from local authorities",
    "1766": "Linens, towels and laundry washed in accordance with local authorities guidelines",
    "1767": "Linen and towels washed in at least 60°C/140°F",
    "1768": "Plates, cutlery, glasses and other tableware sanitised",
    "1769": "High touch surfaces disinfected",
    "1770": "Guest accommodation sealed after cleaning",
    "1771": "Guest accommodation cleaning can be avoided on request",
    "1772": "Staff wear personal protective equipment",
    "1773": "Temperature checks on staff",
    "1774": "Property is vacant for at least 24 hours between reservations.",
    "1775": "Property is vacant for at least 48 hours between reservations.",
    "1776": "Property is vacant for at least 72 hours between reservations.",
    "1777": "Additional COVID-19 related documentation required",
    "1778": "Guests from certain countries not allowed",
    "1779": "Gloves available to guests",
    "1780": "Shared stationery printed menus, pens, paper removed",
    "1781": "First aid kit available",
    "1782": "Cashless payment available",
    "1783": "Property available for essential COVID-19 travellers only",
    "1784": "Reduced hours of service",
    "1785": "Spa & Gym not available",
    "1786": "Services on site reduced",
    "1787": "Shuttle service suspended",
    "1788": "Social distancing in dining areas",
    "1789": "In-room dining options available",
    "1790": "Reduced food services",
    "1791": "Individually-wrapped food for breakfast",
    "1792": "Individually-wrapped food for lunch",
    "1793": "Individually-wrapped food for dinner",
    "1794": "Individually-wrapped food at room service",
    "1795": "Mobile app for room service",
    "1796": "Singapore SG Clean sanitization protocol followed",
    "1797": "Malaysia Safe & Clean sanitization protocol followed",
    "1798": "South Korea CESCO sanitization protocol followed",
    "1799": "Thailand Safety and Health Administration sanitization protocol followed",
    "1801": "Portugal Clean & Safe sanitization protocol followed",
    "1802": "Spain Ministry of Indurstry, Trade & Tourism sanitization protocol followed",
    "1803": "Spain Confederación Española de Hoteles y Alojamientos Turísticos sanitization protocol followed",
    "1804": "Italy Federalberghi National Protocol Accoglienza Sicura (Safe Hospitality) sanitization protocol followed",
    "1805": "Brazil Protected Tourist sanitization protocol followed",
    "1807": "Property follows sanitization practices of Sanitary Protocol (UNPLV - France)",
    "1809": "Property follows sanitization practices of SafeStay (AHLA - USA) ",
    "1810": "Property follows guide to reopening vacation rentals (DTV & DFV - Germany)",
    "1811": "Property follows sanitization practices of European Holiday Home Association (EHHA - Europe)",
    "1812": "Property follows sanitization practices of Intertek Cristal (3rd party expert - Global)",
    "1813": "Property follows sanitization practices of Safe Travels (WTTC - Global)",
    "1814": "Property follows sanitization practices of Croatian Tourism Association (HUT - Croatia)",
    "1815": "Property follows sanitization practices of SafeHome (VRMA & VRHP)",
    "1817": "In-person check-in",
    "1818": "Lockboxes & Key Safes check-in",
    "1819": "Keypad check-in",
    "1820": "Guest should contact us for instructions",
    "1821": "Washer - common space",
    "1822": "Dryer - common space",
    "1823": "Travel crib",
    "1825": "Double futon",
    "1826": "Airbnb: Everyone can make instant booking",
    "1827": "Airbnb: Well reviewed guest can make instant booking",
    "1828": "Airbnb: Guests with verified identity can make instant booking",
    "1829": "Airbnb: Only well reviewed guests with verified identity can make instant booking",
    "1830": "Stairs",
    "1831": "Potential noise",
    "1832": "Pets on property",
    "1833": "Limited parking",
    "1834": "Shared spaces",
    "1835": "Limited amenities",
    "1836": "Weapons on property",
    "1837": "Dangerous animals",
    "1838": "Conditioner",
    "1839": "Rain shower",
    "1840": "Shower gel",
    "1841": "Any of the following: wardrobe, wardrobes, separate closet",
    "1842": "Exercise equipment",
    "1843": "Record player",
    "1844": "Baking sheet",
    "1845": "Bread maker",
    "1846": "Coffee",
    "1847": "Rice maker",
    "1848": "Trash compactor",
    "1849": "Laundromat nearby",
    "1850": "Resort access",
    "1851": "Boat slip",
    "1852": "Hammock",
    "1853": "Outdoor seating",
    "1854": "Outdoor kitchen",
    "1855": "Paid parking on premises",
    "1856": "Long term stays",
    "1857": "Bathroom shared with other guests",
    "1858": "Bathroom shared with the host",
    "1859": "Bathroom shared with family, friends, roommates",
    "1860": "Common spaces shared with other guests",
    "1861": "Common spaces shared with the host",
    "1862": "Common spaces shared with family, friends, roommates",
    "1863": "Surveillance cameras on property",
    "1864": "Fitness Equipment",
    "1865": "Air mattress",
    "1866": "Floor mattress",
    "1867": "BBQ gas",
    "1868": "BBQ charcoal",
    "1869": "Location ocean front",
    "1870": "Chef Fee",
    "1871": "Chef On Request",
    "1873": "Max 1 pet allowed",
    "1874": "Max 2 pets allowed",
    "1875": "Max 3 pets allowed",
    "1876": "Max 4 pets allowed",
    "1877": "Max 5 pets allowed",
    "1878": "Checkout task: Return keys on checking out",
    "1879": "Checkout task: Turn lights/appliances etc off on leaving",
    "1880": "Checkout task: Take care of trash before leaving",
    "1881": "Checkout task: Lock the doors on leaving",
    "1882": "Checkout task: Keep the towels in a specified place",
    "1883": "Checkout task: Turn off lights and air conditioning",
    "1884": "Checkout task: Turn off fans and electronics",
    "1885": "Checkout task: Turn off lights and close windows",
    "1886": "Checkout task: Lock windows and doors",
    "1887": "Checkout task: Lock up and return key",
    "1888": "Checkout task: Lock door and balcony and return key",
    "1889": "Checkout task: Gather towels and linens in linen bag",
    "1890": "Checkout task: Leave towels in the bathroom",
    "1891": "Checkout task: Gather towels and linens",
    "1892": "Checkout task: Clean dishes",
    "1893": "Checkout task: Remove food from the refrigerator",
    "1894": "Checkout task: Empty out the trash and start the dishwasher",
    "1895": "Checkout task: Unclean property will cause cleaning fee",
    "1897": "Checkout task: Dispose of trash in bins or dumpsters",
    "1898": "Checkout task: Recycling instructions",
    "1899": "Checkout task: Trash chutes on specific floors",
    "1900": "Checkout task: Bins/dumpsters outside the property",
    "1901": "Checkout task: Disposal methods in house manual",
    "1902": "Checkout task: Leave keys on the table",
    "1904": "Checkout task: Leave keys in the lockbox",
    "1905": "Checkout task: Leave keys in the key safe",
    "1906": "Checkout task: Leave keys in the kitchen",
    "1907": "Checkout task: Leave keys with staff or security",
    "1908": "Service animals only",
    "1909": "Bicycle parking"
};

window.__pt.ln.propertytype = {
    "1": "All suite",
    "2": "All-Inclusive resort",
    "3": "Apartment",
    "4": "Bed and breakfast",
    "7": "Chalet",
    "8": "Condominium",
    "16": "Guest house",
    "20": "Hotel",
    "22": "Lodge",
    "25": "Mobile-home",
    "30": "Resort",
    "33": "Tent",
    "34": "Vacation home",
    "35": "Villa",
    "37": "Castle",
    "63": "Aparthotel",
    "64": "Boat",
    "65": "Cottage",
    "66": "Camping",
    "67": "House",
    "68": "Private room in apartment",
    "69": "Shared room",
    "70": "Cabin",
    "71": "Bungalow",
    "72": "Riad",
    "73": "Recreational vehicle",
    "74": "Ryokan",
    "75": "Loft",
    "76": "Townhouse"
};

window.__pt.ln.propertyselection = {
    "hotel": "Hotel",
    "accommodation": "Houses or apartments"
};

window.__pt.ln.travelgroup = {
    "959": "Only adults",
    "595": "Pet friendly"
};

window.__pt.ln.propertytypes = {
    "1": "All suite",
    "2": "All-Inclusive resort",
    "3": "Apartment",
    "4": "Bed and breakfast",
    "7": "Chalet",
    "8": "Condominium",
    "16": "Guest house",
    "20": "Hotel",
    "22": "Lodge",
    "25": "Mobile-home",
    "30": "Resort",
    "33": "Tent",
    "34": "Vacation home",
    "35": "Villa",
    "37": "Castle",
    "63": "Aparthotel",
    "64": "Boat",
    "65": "Cottage",
    "66": "Camping",
    "67": "House",
    "68": "Private room in apartment",
    "69": "Shared room",
    "70": "Cabin",
    "71": "Bungalow",
    "72": "Riad",
    "73": "Recreational vehicle",
    "74": "Ryokan",
    "75": "Loft",
    "76": "Townhouse"
};
